/* ARTIST, 2026-10-12 : essai virtuel des teintes de lèvres. Voir snippets/artist-essai-virtuel.liquid.
   Depuis le 2026-10-18 : photo seulement, pas d'essai en direct (lumière changeante, caméras inégales : couleurs moins fidèles).
   La caméra sert seulement à prendre un selfie fixe.
   Détection du visage : MediaPipe Face Landmarker de Google (code ouvert, licence Apache 2.0), chargé au premier clic.
   L'image reste dans le navigateur de la cliente : rien n'est envoyé. */
(function () {
  'use strict';

  // Couleurs de secours, par identifiant de variante, quand le métachamp custom.couleur_essai est vide, mesurées sur les
  // photos produit (calibrer.py, à côté de build.py) : « carre » pour les pastilles; « portee », la teinte telle qu'elle
  // paraît sur les lèvres, pour le rendu; « fini » (mat, creme, brillant, nacre); « peau », la peau sous la bouche sur
  // les photos du produit, qui sert de référence de lumière.
  var COULEURS = {"41911110402180": {"carre": "#b06267", "portee": "#a1545a", "fini": "mat", "peau": [0.5029, 0.2705, 0.2159]}, "41911110697092": {"carre": "#c8727a", "portee": "#b76069", "fini": "mat", "peau": [0.5029, 0.2705, 0.2159]}, "41911110303876": {"carre": "#bf6275", "portee": "#b05668", "fini": "mat", "peau": [0.5029, 0.2705, 0.2159]}, "41911110467716": {"carre": "#cc8888", "portee": "#bd7876", "fini": "mat", "peau": [0.5029, 0.2705, 0.2159]}, "41911110434948": {"carre": "#ca8478", "portee": "#bc766a", "fini": "mat", "peau": [0.5029, 0.2705, 0.2159]}, "41911110500484": {"carre": "#c55e62", "portee": "#b55054", "fini": "mat", "peau": [0.5029, 0.2705, 0.2159]}, "41911110533252": {"carre": "#b0464e", "portee": "#a23c43", "fini": "mat", "peau": [0.5029, 0.2705, 0.2159]}, "41911110566020": {"carre": "#e15871", "portee": "#d14c66", "fini": "mat", "peau": [0.5029, 0.2705, 0.2159]}, "41911110598788": {"carre": "#dc0f27", "portee": "#cd0315", "fini": "mat", "peau": [0.5029, 0.2705, 0.2159]}, "41911110336644": {"carre": "#d70d26", "portee": "#be0517", "fini": "mat", "peau": [0.5029, 0.2705, 0.2159]}, "41911110664324": {"carre": "#b55e6b", "portee": "#a04a58", "fini": "mat", "peau": [0.5029, 0.2705, 0.2159]}, "41911110369412": {"carre": "#ca6880", "portee": "#b14968", "fini": "mat", "peau": [0.5029, 0.2705, 0.2159]}, "41911110631556": {"carre": "#521e27", "portee": "#410f18", "fini": "mat", "peau": [0.5029, 0.2705, 0.2159]}, "41599874695300": {"carre": "#dd827d", "portee": "#d2746f", "fini": "brillant", "peau": [0.9131, 0.5271, 0.402]}, "41599874859140": {"carre": "#c15e5b", "portee": "#b6504b", "fini": "creme", "peau": [0.9131, 0.5271, 0.402]}, "41599874924676": {"carre": "#b5514a", "portee": "#a9433c", "fini": "creme", "peau": [0.9131, 0.5271, 0.402]}, "41599874826372": {"carre": "#b0545e", "portee": "#a44751", "fini": "creme", "peau": [0.9131, 0.5271, 0.402]}, "41599874760836": {"carre": "#d58481", "portee": "#cc716e", "fini": "brillant", "peau": [0.9131, 0.5271, 0.402]}, "41734113591428": {"carre": "#cd8c7b", "portee": "#c2806f", "fini": "creme", "peau": [0.9131, 0.5271, 0.402]}, "41770230775940": {"carre": "#ef8e89", "portee": "#e48380", "fini": "brillant", "peau": [0.9131, 0.5271, 0.402]}, "41599915065476": {"carre": "#ef6677", "portee": "#e15c6c", "fini": "nacre", "peau": [0.7758, 0.3589, 0.281]}, "41599915163780": {"carre": "#b84553", "portee": "#aa3c47", "fini": "brillant", "peau": [0.7758, 0.3589, 0.281]}, "41599914999940": {"carre": "#d75f78", "portee": "#cd586f", "fini": "brillant", "peau": [0.7758, 0.3589, 0.281]}, "41599915131012": {"carre": "#db6362", "portee": "#d05b5b", "fini": "brillant", "peau": [0.7758, 0.3589, 0.281]}, "41599915032708": {"carre": "#ce5865", "portee": "#c04f5c", "fini": "creme", "peau": [0.7758, 0.3589, 0.281]}, "51170906800260": {"carre": "#be555b", "portee": "#af4a50", "fini": "mat", "peau": [0.7758, 0.3589, 0.281]}, "41611772526724": {"carre": "#f28c7c", "portee": "#ec8070", "fini": "creme", "peau": [0.9047, 0.521, 0.402]}, "41611772559492": {"carre": "#fc7f72", "portee": "#fa6e62", "fini": "creme", "peau": [0.9047, 0.521, 0.402]}, "41611772625028": {"carre": "#fd673e", "portee": "#f9582a", "fini": "creme", "peau": [0.9047, 0.521, 0.402]}, "41611772690564": {"carre": "#f26d62", "portee": "#ea6158", "fini": "creme", "peau": [0.9047, 0.521, 0.402]}, "41611772592260": {"carre": "#f67872", "portee": "#f46762", "fini": "creme", "peau": [0.9047, 0.521, 0.402]}, "41611812733060": {"carre": "#c18071", "portee": "#b67565", "fini": "brillant", "peau": [0.9131, 0.5271, 0.4072]}, "41611812700292": {"carre": "#b8705d", "portee": "#ad6552", "fini": "mat", "peau": [0.9131, 0.5271, 0.4072]}, "41611812634756": {"carre": "#bc6f64", "portee": "#b5685c", "fini": "mat", "peau": [0.9131, 0.5271, 0.4072]}, "41611812667524": {"carre": "#be6a54", "portee": "#b8624b", "fini": "brillant", "peau": [0.9131, 0.5271, 0.4072]}, "41611812765828": {"carre": "#b66d5f", "portee": "#ab6657", "fini": "brillant", "peau": [0.9131, 0.5271, 0.4072]}, "41611820892292": {"carre": "#6a3634", "portee": "#5f2a28", "fini": "mat", "peau": [0.9131, 0.5271, 0.4072]}, "41726462230660": {"carre": "#b0645b", "portee": "#a65850", "fini": "creme", "peau": [0.9131, 0.5271, 0.4072]}, "41611829248132": {"carre": "#bb6f5a", "portee": "#b16450", "fini": "creme", "peau": [0.9131, 0.5271, 0.4072]}, "41611829182596": {"carre": "#b16e5a", "portee": "#a56350", "fini": "creme", "peau": [0.9131, 0.5271, 0.4072]}, "41611829215364": {"carre": "#bc7964", "portee": "#ae6d58", "fini": "creme", "peau": [0.9131, 0.5271, 0.4072]}, "41611829280900": {"carre": "#b47060", "portee": "#a96656", "fini": "creme", "peau": [0.9131, 0.5271, 0.4072]}, "41611829379204": {"carre": "#a76254", "portee": "#9b5749", "fini": "creme", "peau": [0.9131, 0.5271, 0.4072]}, "41611856674948": {"carre": "#c26c68", "portee": "#b9625f", "fini": "creme", "peau": [0.4969, 0.1746, 0.1274]}, "41611856609412": {"carre": "#ab6e5e", "portee": "#a26354", "fini": "brillant", "peau": [0.4969, 0.1746, 0.1274]}, "41611856511108": {"carre": "#a7665f", "portee": "#9f5c58", "fini": "brillant", "peau": [0.4969, 0.1746, 0.1274]}, "41611856642180": {"carre": "#c36967", "portee": "#b9605f", "fini": "creme", "peau": [0.4969, 0.1746, 0.1274]}, "41611856543876": {"carre": "#b1725e", "portee": "#a86755", "fini": "creme", "peau": [0.4969, 0.1746, 0.1274]}, "41611856576644": {"carre": "#ae7266", "portee": "#a5685c", "fini": "brillant", "peau": [0.4969, 0.1746, 0.1274]}, "41617620926596": {"carre": "#a8675d", "portee": "#9d5b52", "fini": "mat", "peau": [0.4969, 0.1746, 0.1274]}, "41635077128324": {"carre": "#dc2a41", "portee": "#d01e36", "fini": "creme", "peau": [0.8348, 0.41, 0.3052]}, "41635077193860": {"carre": "#d64153", "portee": "#cc3243", "fini": "creme", "peau": [0.8348, 0.41, 0.3052]}, "41635089907844": {"carre": "#f83b46", "portee": "#ec2e3c", "fini": "brillant", "peau": [0.8348, 0.41, 0.3052]}, "41734105038980": {"carre": "#d94658", "portee": "#c83549", "fini": "creme", "peau": [0.8348, 0.41, 0.3052]}, "41857230504068": {"carre": "#ee5260", "portee": "#e0404e", "fini": "creme", "peau": [0.8348, 0.41, 0.3052]}, "51920623206532": {"carre": "#e44a6e", "portee": "#dc3c62", "fini": "brillant", "peau": [0.8348, 0.41, 0.3052]}, "41637323210884": {"carre": "#c15b60", "portee": "#b85358", "fini": "mat", "peau": [0.7797, 0.3688, 0.2748]}, "41637323243652": {"carre": "#c95358", "portee": "#ba494d", "fini": "creme", "peau": [0.7797, 0.3688, 0.2748]}, "41637323309188": {"carre": "#d94b54", "portee": "#cc454d", "fini": "creme", "peau": [0.7797, 0.3688, 0.2748]}, "41637323341956": {"carre": "#c75d59", "portee": "#b9534e", "fini": "brillant", "peau": [0.7797, 0.3688, 0.2748]}, "41637323374724": {"carre": "#bb4e48", "portee": "#ae463e", "fini": "creme", "peau": [0.7797, 0.3688, 0.2748]}, "41637323440260": {"carre": "#c16460", "portee": "#b45753", "fini": "brillant", "peau": [0.7797, 0.3688, 0.2748]}, "41637380587652": {"carre": "#b84445", "portee": "#b03d3e", "fini": "creme", "peau": [0.7797, 0.3688, 0.2748]}, "41734095077508": {"carre": "#bd6461", "portee": "#b45e59", "fini": "creme", "peau": [0.7797, 0.3688, 0.2748]}, "41637407359108": {"carre": "#bd7073", "portee": "#b06064", "fini": "nacre", "peau": [0.8963, 0.5089, 0.3813]}, "41637407326340": {"carre": "#b26a79", "portee": "#a8606f", "fini": "brillant", "peau": [0.8963, 0.5089, 0.3813]}, "41637415092356": {"carre": "#995262", "portee": "#8d4756", "fini": "creme", "peau": [0.8963, 0.5089, 0.3813]}, "41637407260804": {"carre": "#7b4149", "portee": "#662832", "fini": "creme", "peau": [0.8963, 0.5089, 0.3813]}, "41637407195268": {"carre": "#75203d", "portee": "#681531", "fini": "creme", "peau": [0.8963, 0.5089, 0.3813]}, "41637407129732": {"carre": "#641a1c", "portee": "#5b0f14", "fini": "creme", "peau": [0.8963, 0.5089, 0.3813]}, "41734099173508": {"carre": "#60364e", "portee": "#54273e", "fini": "mat", "peau": [0.8963, 0.5089, 0.3813]}, "41857230569604": {"carre": "#ba6f6d", "portee": "#a95855", "fini": "creme", "peau": [0.8963, 0.5089, 0.3813]}, "50509120667780": {"carre": "#f3e6e1", "portee": "#bb7064", "fini": "gloss", "peau": [0.6412, 0.3073, 0.2125], "couv": 0.0}, "50509120700548": {"carre": "#d17b75", "portee": "#e48683", "fini": "gloss", "peau": [0.6412, 0.3073, 0.2125], "couv": 0.5, "nacre": 0.74, "eclat": "#e9f4ff"}, "50509120733316": {"carre": "#b75948", "portee": "#b64c37", "fini": "gloss", "peau": [0.6412, 0.3073, 0.2125], "couv": 0.7}, "50509120766084": {"carre": "#9d4748", "portee": "#973c41", "fini": "gloss", "peau": [0.6412, 0.3073, 0.2125], "couv": 0.85, "nacre": 0.9, "eclat": "#ffdcd4"}, "50509120798852": {"carre": "#b5264a", "portee": "#b41247", "fini": "gloss", "peau": [0.6412, 0.3073, 0.2125], "couv": 0.91}, "50509120897156": {"carre": "#b43e48", "portee": "#b32e41", "fini": "gloss", "peau": [0.6412, 0.3073, 0.2125], "couv": 0.85}, "50509120929924": {"carre": "#b14667", "portee": "#af3568", "fini": "gloss", "peau": [0.6412, 0.3073, 0.2125], "couv": 0.8}, "50509120962692": {"carre": "#c91c37", "portee": "#ca1134", "fini": "gloss", "peau": [0.6412, 0.3073, 0.2125], "couv": 0.95}, "50509120995460": {"carre": "#a84443", "portee": "#a4383b", "fini": "gloss", "peau": [0.6412, 0.3073, 0.2125], "couv": 0.85}, "50509121028228": {"carre": "#c17a70", "portee": "#c6847a", "fini": "gloss", "peau": [0.6412, 0.3073, 0.2125], "couv": 0.5, "nacre": 0.34, "eclat": "#e5fffa"}, "50509121060996": {"carre": "#d88077", "portee": "#f08e86", "fini": "gloss", "peau": [0.6412, 0.3073, 0.2125], "couv": 0.5, "nacre": 0.68, "eclat": "#ffe1c8"}, "50509121093764": {"carre": "#d06d69", "portee": "#e26b6e", "fini": "gloss", "peau": [0.6412, 0.3073, 0.2125], "couv": 0.5, "nacre": 0.65, "eclat": "#ffebd6"}, "51688814084228": {"carre": "#b76057", "portee": "#b65851", "fini": "gloss", "peau": [0.6412, 0.3073, 0.2125], "couv": 0.7, "nacre": 0.64, "eclat": "#ffd9ba"}, "50509121126532": {"carre": "#e9879a", "portee": "#f58ea7", "fini": "gloss", "peau": [0.6412, 0.3073, 0.2125], "couv": 0.76}, "50509121159300": {"carre": "#d57677", "portee": "#ec7c87", "fini": "gloss", "peau": [0.6412, 0.3073, 0.2125], "couv": 0.5, "nacre": 0.65, "eclat": "#f6f6fc"}, "50509121192068": {"carre": "#e0766e", "portee": "#f57a74", "fini": "gloss", "peau": [0.6412, 0.3073, 0.2125], "couv": 0.6, "nacre": 0.9, "eclat": "#ffebda"}, "44607509463172": {"carre": "#cb8075", "portee": "#d48b7d", "fini": "huile", "peau": [0.7157, 0.3467, 0.2346], "couv": 0.5}, "44607500025988": {"carre": "#c95e53", "portee": "#cc5243", "fini": "huile", "peau": [0.7157, 0.3467, 0.2346], "couv": 0.68}, "44607500058756": {"carre": "#d06160", "portee": "#d75256", "fini": "huile", "peau": [0.7157, 0.3467, 0.2346], "couv": 0.6}, "50509132660868": {"carre": "#ab564b", "portee": "#ab564b", "fini": "satin", "peau": [0.772, 0.4536, 0.3302], "couv": 0.96}, "50509132693636": {"carre": "#943b41", "portee": "#943b41", "fini": "satin", "peau": [0.772, 0.4536, 0.3302], "couv": 0.96}, "50509132726404": {"carre": "#ad010c", "portee": "#ad020c", "fini": "satin", "peau": [0.772, 0.4536, 0.3302], "couv": 0.96}, "50509132759172": {"carre": "#a9485a", "portee": "#a9485a", "fini": "satin", "peau": [0.772, 0.4536, 0.3302], "couv": 0.96}, "50509132791940": {"carre": "#cc7681", "portee": "#cc7681", "fini": "satin", "peau": [0.772, 0.4536, 0.3302], "couv": 0.96}, "50509132824708": {"carre": "#ce6f6a", "portee": "#ce6f6a", "fini": "satin", "peau": [0.772, 0.4536, 0.3302], "couv": 0.96}};

  var racine = document.querySelector('[data-artist-essai]');
  if (!racine || racine.dataset.pret) return;
  racine.dataset.pret = '1';
  var donnees = JSON.parse(racine.querySelector('[data-essai-donnees]').textContent);

  // Textes de la fenêtre : en anglais sur la version anglaise du site (/en), en français partout ailleurs
  var EN = /^en/i.test(document.documentElement.lang || '');
  var T = EN ? {
    essai: 'Virtual try-on', fermer: 'Close', apercu: 'Preview of the shade on your face', ajuster: 'Adjust lips',
    agrandir: 'View the photo full screen', avant: 'Before', apres: 'After',
    vide: 'Take a selfie or choose a photo of yourself, in good light.', selfie: 'Take a selfie', choisir: 'Choose a photo',
    reinit: 'Reset', ok: 'Done', nouveauSelfie: 'New selfie', changer: 'Change photo', teintes: 'Shades',
    comparer: 'Before / after', ajouter: 'Add to cart',
    note: 'Your photo stays on your device. Nothing is sent or saved. The on-screen shade may differ from the actual shade depending on lighting.',
    annuler: 'Cancel', utiliser: 'Use', conseil: 'For best results: stand in front of a good light source.',
    prendre: 'Take the photo', plein: 'Your try-on, full screen', fermerPlein: 'Close full screen',
    sans: 'No makeup', aucune: 'None', epuiseeDetail: ' · sold out', epuisee: 'Sold out', ajout: 'Adding…',
    reessayer: 'Try again', erreurPanier: 'Adding to cart didn\'t work. Check your internet connection, then try again.',
    chargement: 'Loading the try-on…', echecChargement: 'The try-on could not load. Check your internet connection, then try again.',
    aucunVisage: 'No face found in this photo. Tap “Adjust lips” to place them yourself.',
    imageIllisible: 'This image could not be opened. Try another photo.',
    cameraAbsente: 'The camera is not available in this browser. Choose a photo instead.',
    cameraRefusee: 'The camera is not available. Allow it in your browser, or choose a photo.',
    votreEssai: 'Your try-on: ', sansMin: 'no makeup', teinte: 'Shade ',
    accordTitre: 'Before you start',
    accord: ['Your photo stays on your device. It is never sent or saved.',
      'The try-on only finds the outline of your lips to apply the shade. It is not used to recognize you.',
      'Everything is cleared when you leave the page.'],
    accordOk: 'I agree and continue', politique: 'Privacy policy'
  } : {
    essai: 'Essai virtuel', fermer: 'Fermer', apercu: 'Aperçu de la teinte sur le visage', ajuster: 'Ajuster les lèvres',
    agrandir: 'Voir la photo en plein écran', avant: 'Avant', apres: 'Après',
    vide: 'Prenez un selfie ou choisissez une photo de vous, dans une bonne lumière.', selfie: 'Prendre un selfie', choisir: 'Choisir une photo',
    reinit: 'Réinitialiser', ok: 'Terminé', nouveauSelfie: 'Nouveau selfie', changer: 'Changer de photo', teintes: 'Teintes',
    comparer: 'Avant / après', ajouter: 'Ajouter au panier',
    note: 'L\'image reste sur votre appareil. Rien n\'est envoyé ni enregistré. Le rendu à l\'écran peut différer de la teinte réelle selon l\'éclairage.',
    annuler: 'Annuler', utiliser: 'Utiliser', conseil: 'Pour un résultat optimal : placez-vous devant une bonne source de lumière.',
    prendre: 'Prendre la photo', plein: 'Votre essai en plein écran', fermerPlein: 'Fermer le plein écran',
    sans: 'Sans maquillage', aucune: 'Aucune', epuiseeDetail: ' · épuisée', epuisee: 'Teinte épuisée', ajout: 'Ajout…',
    reessayer: 'Réessayer', erreurPanier: 'L\'ajout au panier n\'a pas fonctionné. Vérifiez la connexion internet, puis réessayez.',
    chargement: 'Chargement de l\'essai…', echecChargement: 'L\'essai n\'a pas pu se charger. Vérifiez la connexion internet, puis réessayez.',
    aucunVisage: 'Aucun visage trouvé sur cette photo. Touchez « Ajuster les lèvres » pour les placer vous-même.',
    imageIllisible: 'Cette image n\'a pas pu s\'ouvrir. Essayez une autre photo.',
    cameraAbsente: 'La caméra n\'est pas accessible dans ce navigateur. Choisissez plutôt une photo.',
    cameraRefusee: 'La caméra n\'est pas accessible. Autorisez-la dans votre navigateur, ou choisissez une photo.',
    votreEssai: 'Votre essai : ', sansMin: 'sans maquillage', teinte: 'Teinte ',
    accordTitre: 'Avant de commencer',
    accord: ['Votre photo reste sur votre appareil. Elle n\'est jamais envoyée ni enregistrée.',
      'L\'essai repère seulement le contour de votre bouche pour y poser la teinte. Il ne sert pas à vous reconnaître.',
      'Tout s\'efface quand vous quittez la page.'],
    accordOk: 'J\'accepte et je continue', politique: 'Politique de confidentialité'
  };
  var FINIS_EN = { mat: 'Matte', creme: 'Cream', brillant: 'Glossy', nacre: 'Pearl' };
  var POLITIQUE = String(donnees.panier || '/cart/add').replace(/\/cart\/add$/, '') + '/policies/privacy-policy';
  // L'accord est retenu sur l'appareil (une date, rien d'autre); sans stockage permis, il vaut pour la visite
  var ACCORD = 'aev-accord-v1', accordVisite = false;
  function accordDonne() {
    if (accordVisite) return true;
    try { return !!localStorage.getItem(ACCORD); } catch (e) { return false; }
  }
  var teintes = donnees.teintes.map(function (t) {
    var secours = COULEURS[t.id] || {}, portee = (t.couleur || secours.portee || '').trim();
    // « 450 - Brillant » (rouges à lèvres) ou « La loyale 55 » (Velours)
    var num = String(t.nom).match(/^(\d+)\s*-\s*(.+)$/), nom = String(t.nom).match(/^(.*?)\s+(\d+)\s*$/);
    // « 02 Beige » (Huile à lèvres; « O1 café » porte une lettre O au lieu du zéro dans la boutique)
    var avant = !num && !nom && String(t.nom).match(/^([O0-9]\d*)\s+([^\s\d-].*)$/);
    if (avant) nom = [null, avant[2].charAt(0).toUpperCase() + avant[2].slice(1), avant[1].replace(/^O/, '0')];
    // en anglais, les noms traduits par la boutique sont peu fiables (« 554 by Monelle - Glossy ») : le numéro, puis le
    // fini connu de la teinte
    var numEn = EN && String(t.nom).match(/^(\d+)\b/);
    if (numEn && FINIS_EN[secours.fini]) num = [null, numEn[1], FINIS_EN[secours.fini]];
    return {
      id: t.id, dispo: t.dispo, portee: portee, couleur: secours.carre || portee, fini: secours.fini, peau: secours.peau,
      // couv : part de la couleur qui couvre la lèvre (gloss et huile laissent voir la lèvre); nacre et eclat : paillettes
      couv: secours.couv, nacre: secours.nacre, eclat: secours.eclat,
      libelle: num ? T.teinte + num[1] : nom ? nom[1] : t.nom,
      detail: num ? num[2].trim() : nom ? T.teinte + nom[2] : ''
    };
  }).filter(function (t) { return /^#[0-9a-f]{6}$/i.test(t.portee) && /^#[0-9a-f]{6}$/i.test(t.couleur); });
  if (!teintes.length) return;
  racine.hidden = false;

  var VISION = 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14';
  var MODELE_VISAGE = 'https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task';
  var LEVRES_EXT = [61,146,91,181,84,17,314,405,321,375,291,409,270,269,267,0,37,39,40,185];
  var LEVRES_INT = [78,95,88,178,87,14,317,402,318,324,308,415,310,311,312,13,82,81,80,191];
  var NB_EXT = LEVRES_EXT.length;
  var POIGNEES = [61, 91, 17, 321, 291, 270, 267, 0, 37, 40, 13, 14];
  var COINS = { 61: 78, 291: 308 };
  // Forme de lèvres de départ pour placer les lèvres à la main quand aucun visage n'est trouvé :
  // les 40 points du contour, centrés et ramenés à une largeur de 1 (mesurés sur une modèle ARTIST).
  var GABARIT = [[-0.5,0.062],[-0.442,0.092],[-0.365,0.115],[-0.257,0.138],[-0.131,0.148],[0.004,0.146],[0.143,0.136],[0.269,0.115],[0.374,0.084],[0.448,0.052],[0.5,0.019],[0.45,-0.021],[0.374,-0.065],[0.271,-0.11],[0.132,-0.148],[-0.003,-0.119],[-0.138,-0.138],[-0.277,-0.088],[-0.375,-0.033],[-0.449,0.016],[-0.457,0.054],[-0.382,0.041],[-0.31,0.026],[-0.217,0.012],[-0.113,0],[0.002,-0.002],[0.117,-0.006],[0.224,-0.007],[0.314,0],[0.386,0.008],[0.458,0.015],[0.379,0.007],[0.307,-0.001],[0.216,-0.009],[0.113,-0.009],[-0.002,-0.006],[-0.114,-0.002],[-0.216,0.008],[-0.307,0.025],[-0.38,0.04]];

  // ---------- lumière de la photo ----------
  // Chaque teinte est rendue avec sa couleur portée, mesurée sur sa photo produit : lumière de studio, peau de la modèle
  // (PEAU_STUDIO). Sur la photo de la cliente, la peau autour de la bouche dit de combien sa lumière diffère de ce studio :
  // plus sombre, plus vive, plus chaude, plus froide. La teinte suit cet écart en bonne partie, pas en entier : une peau
  // plus foncée que celle de la modèle ne doit pas assombrir le rouge à lèvres d'autant.
  // Tout le calcul se fait en lumière linéaire, pas en valeurs d'écran : sinon ombres et reflets tournent faux.
  var PEAU_BOUCHE = [164, 18, 200, 216, 436];   // philtrum, menton, joues au coin de la bouche
  var PEAU_STUDIO = [0.503, 0.271, 0.216];      // peau sous la bouche sur les photos du Velours, quand la teinte n'a pas la sienne
  var SUIVI_EXPO = 0.65, SUIVI_COULEUR = 0.6;
  // Les finis. relief : 10e et 90e centiles de la clarté de la lèvre, sur sa médiane (mesuré 0,63 et 1,71 sur les photos du
  // Velours mat; le haut est ramené à 1,5 parce que le studio éclaire fort le bas de la lèvre). reflet : part de la lumière
  // ajoutée en blanc sur les parties les plus claires de la lèvre, et sur un reflet posé au centre de la lèvre du bas.
  // nacre : grain de reflets fins. Les photos produit des rouges sont une même photo recolorée : elles ne montrent pas le
  // fini, ces réglages sont donc faits à l'œil.
  // mouille : reflets nets posés là où une lèvre bombée accroche la lumière (milieu de la lèvre du bas, sommets de la
  // lèvre du haut), découpés par les plis de la lèvre, comme un gloss ou une huile. Réglés sur les photos de la boutique
  // (19 octobre 2026) : Gloss et Huile à lèvres (avant / après de l'huile), Crème à lèvres pour le satiné.
  var FINIS = {
    // Rouges à lèvres : brillance adoucie le 20 octobre 2026 (« un peu trop glossy », Jimmy, après Marilyn la veille).
    // Plus aucune tache de lumière floue posée par-dessus la lèvre (tache : 0); un rouge crème luit à peine, un rouge
    // Glossy brille, sans jamais avoir l'air mouillé comme un gloss.
    mat: { relief: [0.63, 1.5], reflet: 0, nacre: 0 },
    creme: { relief: [0.62, 1.35], reflet: 0.05, nacre: 0, tache: 0 },
    // brillant (rouges Glossy) : ses reflets naissent sur la lèvre, comme le gloss, en plus discret
    brillant: { relief: [0.6, 1.45], reflet: 0.15, nacre: 0, mouille: 0.18, hautLevre: 0.35, bord: true },
    nacre: { relief: [0.62, 1.4], reflet: 0.08, nacre: 0.4, tache: 0 },
    satin: { relief: [0.6, 1.5], reflet: 0.3, nacre: 0, mouille: 0.3 },
    // gloss et huile, refaits le 22 octobre 2026 (« effet cartoon », Jimmy) : stries = [part de la lueur douce, part des
    // stries fines sur les crêtes entre les plis]; teinteReflet = part de la couleur du produit dans le reflet
    gloss: { relief: [0.56, 1.5], reflet: 0.25, nacre: 0, mouille: 0.7, stries: [0.6, 0.9], teinteReflet: 0.25 },
    huile: { relief: [0.55, 1.45], reflet: 0.25, nacre: 0, mouille: 0.75, stries: [0.6, 0.9], teinteReflet: 0.25 }
  };
  var COUVRANCE = 0.97;
  var SEUIL_BORD = 0.6;   // chute de rougeur minimale, sur la largeur de la bouche, pour qu'un point du contour bouge       // fini opaque : la lèvre d'origine ne transparaît que par son relief
  var VERS_LIN = new Float32Array(256), VERS_ECRAN = new Uint8ClampedArray(4097);
  (function () {
    for (var k = 0; k < 256; k++) { var c = k / 255; VERS_LIN[k] = c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); }
    for (k = 0; k <= 4096; k++) { var l = k / 4096; VERS_ECRAN[k] = Math.round(255 * (l <= 0.0031308 ? l * 12.92 : 1.055 * Math.pow(l, 1 / 2.4) - 0.055)); }
  })();
  function ecran(l) { return VERS_ECRAN[l <= 0 ? 0 : l >= 1 ? 4096 : (l * 4096 + 0.5) | 0]; }
  function lumLin(r, g, b) { return 0.2126 * r + 0.7152 * g + 0.0722 * b; }
  function mediane(t) { t.sort(function (a, b) { return a - b; }); return t[t.length >> 1]; }

  var fenetre, toile, ctx, masque, mctx;
  var detecteur = null, promesseDetecteur = null;
  var source = null, urlActuelle = null;
  var teinte = teintes[0], points = null, pointsDetectes = null, gabaritLevres = GABARIT;
  var repere = null, peauCliente = null;   // les 478 points du visage détecté, et la peau autour de sa bouche
  var comparer = false, coupe = 0.5;
  var ajustement = false, vue = { Z: 1, tx: 0, ty: 0 }, glisse = null, doigts = new Map(), pince = null;

  function $(sel) { return fenetre.querySelector(sel); }
  function etat(texte) { var e = $('.aev__etat'); e.hidden = !texte; e.textContent = texte || ''; fenetre.classList.toggle('aev--message', !!texte); }

  // ---------- fenêtre ----------
  function construire() {
    fenetre = document.createElement('div');
    // Vie privée (19-21 octobre 2026, remarque d'Etienne) : Clarity, Hotjar et PostHog enregistrent les séances des
    // visiteuses qui acceptent les témoins. La fenêtre d'essai est exclue de ces enregistrements : ph-no-capture et
    // rr-block (PostHog), data-hj-suppress (Hotjar), data-clarity-mask (Clarity). La photo n'est jamais mise dans la
    // page sous forme d'adresse data: (voir ouvrirPlein) : un enregistrement ne peut donc pas la copier.
    fenetre.className = 'aev ph-no-capture rr-block';
    fenetre.setAttribute('data-hj-suppress', '');
    fenetre.setAttribute('data-clarity-mask', 'true');
    fenetre.setAttribute('role', 'dialog');
    fenetre.setAttribute('aria-modal', 'true');
    fenetre.setAttribute('aria-label', T.essai);
    fenetre.innerHTML =
      '<div class="aev__boite">' +
        '<button type="button" class="aev__fermer" aria-label="' + T.fermer + '">×</button>' +
        '<div class="aev__scene">' +
          '<canvas width="672" height="900" aria-label="' + T.apercu + '"></canvas>' +
          '<div class="aev__poignee" hidden></div>' +
          // posé sur la photo, là où la cliente regarde quand la teinte déborde (demande de Jimmy, 18 octobre 2026)
          '<button type="button" class="aev__ajuster" hidden>' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" aria-hidden="true">' +
              '<path d="M3 12c2.6-3.2 5.1-4.8 6.6-4.8 1 0 1.8.6 2.4 1.3.6-.7 1.4-1.3 2.4-1.3 1.5 0 4 1.6 6.6 4.8-2.6 3.4-5.6 5-9 5s-6.4-1.6-9-5z"/>' +
              '<path d="M3 12h18" stroke-dasharray="2 2"/><circle cx="3" cy="12" r="1.6" fill="currentColor"/>' +
              '<circle cx="21" cy="12" r="1.6" fill="currentColor"/><circle cx="12" cy="17" r="1.6" fill="currentColor"/></svg>' +
            '<span>' + T.ajuster + '</span></button>' +
          // rappel que la photo s'agrandit : utile sur téléphone, où la photo est réduite pour laisser voir l'ajout au panier
          '<button type="button" class="aev__agrandir" hidden aria-label="' + T.agrandir + '">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
              '<path d="M14 4h6v6M10 20H4v-6M20 4l-7 7M4 20l7-7"/></svg></button>' +
          '<div class="aev__etiquette aev__etiquette--avant" hidden>' + T.avant + '</div>' +
          '<div class="aev__etiquette aev__etiquette--apres" hidden>' + T.apres + '</div>' +
          '<div class="aev__vide"><div><p>' + T.vide + '</p>' +
            '<div class="aev__sources-vide"><button type="button" class="aev__selfie-ouvrir aev__source--principale">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 8.5A2.5 2.5 0 0 1 6.5 6h1.6l1.4-2h5l1.4 2h1.6A2.5 2.5 0 0 1 20 8.5v8a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 16.5z"/><circle cx="12" cy="12.5" r="3.5"/></svg>' + T.selfie + '</button>' +
            '<button type="button" class="aev__choisir">' + T.choisir + '</button></div></div></div>' +
          // avis et accord avant le premier essai : ce que l'essai fait de la photo, en trois phrases (Loi 25 au Québec;
          // aux États-Unis, les poursuites contre les essais virtuels visent l'absence d'avis et d'accord)
          '<div class="aev__accord" hidden><div>' +
            '<p class="aev__accord-titre">' + T.accordTitre + '</p>' +
            '<ul>' + T.accord.map(function (l) { return '<li>' + l + '</li>'; }).join('') + '</ul>' +
            '<button type="button" class="aev__accord-ok aev__source--principale">' + T.accordOk + '</button>' +
            '<a class="aev__accord-lien" href="' + POLITIQUE + '" target="_blank" rel="noopener">' + T.politique + '</a>' +
          '</div></div>' +
          '<div class="aev__etat" hidden></div>' +
          '<div class="aev__calque" hidden></div>' +
          '<div class="aev__barre" hidden>' +
            '<button type="button" class="aev__reinit">' + T.reinit + '</button><button type="button" class="aev__ok">' + T.ok + '</button></div>' +
        '</div>' +
        '<div class="aev__panneau">' +
          '<div class="aev__entete"><div class="aev__surtitre">' + T.essai + '</div><div class="aev__produit"></div></div>' +
          '<div class="aev__sources" hidden><button type="button" class="aev__selfie-ouvrir">' + T.nouveauSelfie + '</button>' +
            '<button type="button" class="aev__changer">' + T.changer + '</button></div>' +
          '<input type="file" accept="image/*" hidden>' +
          '<div class="aev__bloc-teintes"><div class="aev__titre-teintes">' + T.teintes + '</div><div class="aev__teintes"></div></div>' +
          '<div class="aev__choix"><strong></strong><span></span></div>' +
          '<div class="aev__actions"><button type="button" class="aev__comparer" aria-pressed="false">' + T.comparer + '</button>' +
            '<button type="button" class="aev__ajouter">' + T.ajouter + '</button></div>' +
          '<p class="aev__note">' + T.note + '</p>' +
        '</div>' +
      '</div>' +
      '<div class="aev__recadre" hidden>' +
        '<div class="aev__barre-recadre"><button type="button" class="aev__annuler">' + T.annuler + '</button>' +
          '<button type="button" class="aev__utiliser">' + T.utiliser + '</button></div>' +
        '<div class="aev__recadre-zone"><canvas></canvas></div>' +
      '</div>' +
      // comme l'appareil photo de l'iPhone : l'aperçu en haut, le déclencheur rond dessous, à portée du pouce
      '<div class="aev__selfie" hidden>' +
        '<div class="aev__selfie-cadre"><video playsinline muted autoplay></video>' +
          '<p class="aev__selfie-conseil">' + T.conseil + '</p>' +
          '<div class="aev__selfie-eclair"></div></div>' +
        '<div class="aev__selfie-commandes"><button type="button" class="aev__selfie-annuler">' + T.annuler + '</button>' +
          '<button type="button" class="aev__selfie-prendre" aria-label="' + T.prendre + '" disabled></button><span></span></div>' +
      '</div>' +
      // la photo essayée en plein écran : un toucher l'ouvre, un autre la referme
      '<div class="aev__plein" hidden role="dialog" aria-label="' + T.plein + '">' +
        '<img alt=""><div class="aev__plein-legende"></div>' +
        '<button type="button" class="aev__plein-fermer" aria-label="' + T.fermerPlein + '">×</button>' +
      '</div>';
    toile = $('.aev__scene canvas');
    ctx = toile.getContext('2d', { willReadFrequently: true });
    masque = document.createElement('canvas');
    mctx = masque.getContext('2d', { willReadFrequently: true });

    $('.aev__produit').textContent = donnees.produit;

    var boite = $('.aev__teintes');
    var liste = [{ libelle: T.sans, detail: '', couleur: null }].concat(teintes);
    liste.forEach(function (t) {
      var b = document.createElement('button');
      b.type = 'button';
      if (t.couleur) b.style.background = t.couleur; else { b.className = 'aev-sans'; b.textContent = T.aucune; }
      if (t.dispo === false) b.classList.add('aev-epuise');
      b.setAttribute('aria-label', t.detail ? t.libelle + ', ' + t.detail : t.libelle);
      b.title = b.getAttribute('aria-label');
      b._teinte = t;
      b.addEventListener('click', function () { choisir(t); });
      boite.appendChild(b);
    });


    // sur téléphone, le sélecteur propose aussi de prendre la photo sur le coup (appareil photo du téléphone)
    fenetre.querySelectorAll('.aev__choisir, .aev__changer').forEach(function (b) {
      b.addEventListener('click', function () { $('input[type=file]').click(); });
    });
    fenetre.querySelectorAll('.aev__selfie-ouvrir').forEach(function (b) { b.addEventListener('click', ouvrirSelfie); });
    $('.aev__selfie-annuler').addEventListener('click', fermerSelfie);
    $('.aev__selfie-prendre').addEventListener('click', prendreSelfie);
    toile.addEventListener('click', ouvrirPlein);
    $('.aev__agrandir').addEventListener('click', ouvrirPlein);
    $('.aev__plein').addEventListener('click', fermerPlein);
    var urlFichier = null;
    $('input[type=file]').addEventListener('change', function (e) {
      var f = e.target.files[0]; if (!f) return;
      if (urlFichier) URL.revokeObjectURL(urlFichier);
      urlFichier = URL.createObjectURL(f);
      ouvrirRecadrage(urlFichier);
      e.target.value = '';
    });
    $('.aev__comparer').addEventListener('click', function () {
      if (ajustement) quitterAjustement();
      comparer = !comparer; coupe = 0.5;
      $('.aev__comparer').setAttribute('aria-pressed', String(comparer));
      fenetre.classList.toggle('aev--compare', comparer);
      ['.aev__poignee', '.aev__etiquette--avant', '.aev__etiquette--apres'].forEach(function (s) { $(s).hidden = !comparer; });
      $('.aev__poignee').style.left = '50%';
      dessiner();
    });
    $('.aev__ajouter').addEventListener('click', ajouterAuPanier);
    $('.aev__accord-ok').addEventListener('click', function () {
      accordVisite = true;
      try { localStorage.setItem(ACCORD, new Date().toISOString()); } catch (e) { /* navigation privée : vaut pour la visite */ }
      majAccord();
      preparerDetecteur();
      var b = $('.aev__vide .aev__selfie-ouvrir'); if (b) b.focus({ preventScroll: true });
    });
    $('.aev__fermer').addEventListener('click', fermer);
    fenetre.addEventListener('click', function (e) { if (e.target === fenetre) fermer(); });
    $('.aev__ajuster').addEventListener('click', entrerAjustement);
    $('.aev__ok').addEventListener('click', quitterAjustement);
    $('.aev__reinit').addEventListener('click', function () {
      if (pointsDetectes) points = copie(pointsDetectes); else if (gabaritLevres) placerGabarit();
      dessiner(); placerPoints();
    });

    var scene = $('.aev__scene');
    scene.addEventListener('pointerdown', function (e) { if (!comparer || ajustement) return; capturer(scene, e.pointerId); suivre(e); });
    scene.addEventListener('pointermove', function (e) { if (e.buttons && comparer && !ajustement) suivre(e); });
    brancherCalque();
    brancherRecadrage();
  }

  // sans accord : l'avis à la place des boutons de photo; rien ne se charge avant
  function majAccord() {
    var ok = accordDonne();
    $('.aev__accord').hidden = ok || !!source;
    if (!source) $('.aev__vide').hidden = !ok;
  }
  var appelFait = false;
  function majPhoto() {
    $('.aev__sources').hidden = !source;
    $('.aev__agrandir').hidden = !source;
    // sans photo, « Avant / après » ne montrerait rien : seul l'achat reste, sur toute la largeur
    $('.aev__comparer').hidden = !source;
    $('.aev__actions').classList.toggle('aev__actions--seul', !source);
    // caché pendant le chargement de la détection seulement : si elle échoue, la cliente place ses lèvres à la main
    var aj = $('.aev__ajuster');
    aj.hidden = !source || (!detecteur && !!promesseDetecteur);
    if (!aj.hidden && !appelFait) {
      // la première fois, le bouton pulse deux fois pour se faire remarquer
      appelFait = true; aj.classList.add('aev__ajuster--appel');
      setTimeout(function () { aj.classList.remove('aev__ajuster--appel'); }, 2800);
    }
  }
  var erreurPanier = false;
  function choisir(t) {
    teinte = t;
    if (erreurPanier) { erreurPanier = false; etat(''); }
    var rangee = $('.aev__teintes');
    rangee.querySelectorAll('button').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b._teinte === t));
      // sur téléphone la rangée défile : on amène la teinte choisie en vue, sans bouger la page
      if (b._teinte === t && rangee.scrollWidth > rangee.clientWidth) { var rr = rangee.getBoundingClientRect(), rb = b.getBoundingClientRect(); rangee.scrollLeft += (rb.left - rr.left) - (rr.width - rb.width) / 2; }
    });
    $('.aev__choix strong').textContent = t.libelle;
    $('.aev__choix span').textContent = (t.detail || '') + (t.dispo === false ? T.epuiseeDetail : '');
    var ajouter = $('.aev__ajouter');
    ajouter.hidden = !t.id;
    ajouter.disabled = t.dispo === false;
    ajouter.textContent = t.dispo === false ? T.epuisee : T.ajouter;
    dessiner();
  }

  function varianteDeLaPage() {
    var id = new URLSearchParams(location.search).get('variant');
    var champ = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!id && champ) id = champ.value;
    return teintes.filter(function (t) { return String(t.id) === String(id); })[0];
  }

  function ouvrir() {
    if (!fenetre) construire();
    document.body.appendChild(fenetre);
    document.documentElement.classList.add('aev-ouvert');
    barreApercu(true);
    choisir(varianteDeLaPage() || teinte);
    majPhoto();
    majAccord();
    document.addEventListener('keydown', echap);
    if (accordDonne()) preparerDetecteur();
    $('.aev__fermer').focus({ preventScroll: true });
  }
  function fermer() {
    if (ajustement) quitterAjustement();
    if (fenetre && !$('.aev__recadre').hidden) fermerRecadrage();
    if (fenetre && !$('.aev__selfie').hidden) fermerSelfie();
    if (fenetre) fermerPlein();
    document.removeEventListener('keydown', echap);
    document.documentElement.classList.remove('aev-ouvert');
    barreApercu(false);
    if (fenetre && fenetre.parentNode) fenetre.parentNode.removeChild(fenetre);
    var bouton = racine.querySelector('[data-essai-ouvrir]'); if (bouton) bouton.focus({ preventScroll: true });
  }
  function echap(e) {
    if (e.key !== 'Escape') return;
    if (!$('.aev__plein').hidden) fermerPlein(); else fermer();
  }

  // ---------- plein écran ----------
  var urlPlein = null;
  function ouvrirPlein() {
    if (!source || comparer || ajustement) return;
    var plein = $('.aev__plein'), img = plein.querySelector('img');
    // une adresse blob: n'existe que dans cette page; une adresse data: mettrait la photo elle-même dans la page
    toile.toBlob(function (b) {
      if (!b || plein.hidden) return;
      if (urlPlein) URL.revokeObjectURL(urlPlein);
      urlPlein = URL.createObjectURL(b); img.src = urlPlein;
    }, 'image/jpeg', 0.92);
    plein.querySelector('img').alt = T.votreEssai + (teinte.couleur ? teinte.libelle + (teinte.detail ? ', ' + teinte.detail : '') : T.sansMin);
    plein.querySelector('.aev__plein-legende').textContent = teinte.couleur ? teinte.libelle + (teinte.detail ? ' · ' + teinte.detail : '') : T.sans;
    plein.hidden = false;
    plein.querySelector('.aev__plein-fermer').focus({ preventScroll: true });
  }
  function fermerPlein() {
    var plein = $('.aev__plein');
    if (plein.hidden) return;
    plein.hidden = true; plein.querySelector('img').removeAttribute('src');
    if (urlPlein) { URL.revokeObjectURL(urlPlein); urlPlein = null; }
  }

  function ajouterAuPanier() {
    if (!teinte.id || teinte.dispo === false) return;
    var b = $('.aev__ajouter'); b.disabled = true; b.textContent = T.ajout;
    fetch(donnees.panier + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: teinte.id, quantity: 1 }] })
    }).then(function (r) {
      // Shopify explique le refus en français (stock insuffisant, teinte déjà toute au panier) : on le montre tel quel
      if (!r.ok) return r.json().catch(function () { return {}; }).then(function (e) { throw new Error(e.description || e.message || ''); });
      return fetch(donnees.panierJs);
    })
      .then(function (r) { return r.json(); })
      .then(function (panier) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: panier }, bubbles: true }));
        fermer();
        var tiroir = document.querySelector('[data-drawer="drawer-cart"]');
        if (tiroir) tiroir.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
        else location.href = donnees.panierJs.replace(/\.js$/, '');
      })
      .catch(function (e) {
        b.textContent = T.reessayer;
        erreurPanier = true;
        etat(e && e.message && !/fetch|network|load/i.test(e.message) ? e.message : T.erreurPanier);
      })
      .then(function () { if (fenetre) { b.disabled = teinte.dispo === false; if (b.textContent === T.ajout) b.textContent = T.ajouter; } });
  }

  // ---------- détection ----------
  // Shopify compresse les fichiers du thème et réécrit import() en require(), inconnu du navigateur :
  // le module de MediaPipe se charge donc par une petite balise <script type="module"> qui renvoie le résultat.
  function importer(url) {
    return new Promise(function (ok, ko) {
      var nom = 'aev-module-' + Date.now();
      var delai = setTimeout(function () { ko(new Error('délai dépassé: ' + url)); }, 45000);
      window.addEventListener(nom, function (e) { clearTimeout(delai); if (e.detail.erreur) ko(new Error(e.detail.erreur)); else ok(e.detail.module); }, { once: true });
      var s = document.createElement('script');
      s.type = 'module';
      s.textContent = 'import(' + JSON.stringify(url) + ').then(function (m) { window.dispatchEvent(new CustomEvent(' + JSON.stringify(nom) + ', { detail: { module: m } })); })' +
        '.catch(function (e) { window.dispatchEvent(new CustomEvent(' + JSON.stringify(nom) + ', { detail: { erreur: String(e) } })); });';
      document.head.appendChild(s);
    });
  }
  function preparerDetecteur() {
    if (promesseDetecteur) return promesseDetecteur;
    etat(T.chargement);
    promesseDetecteur = importer(VISION + '/vision_bundle.mjs').then(function (vision) {
      return vision.FilesetResolver.forVisionTasks(VISION + '/wasm').then(function (fichiers) {
        function options(delegate) { return { baseOptions: { modelAssetPath: MODELE_VISAGE, delegate: delegate }, runningMode: 'IMAGE', numFaces: 1 }; }
        return vision.FaceLandmarker.createFromOptions(fichiers, options('GPU'))
          .catch(function () { return vision.FaceLandmarker.createFromOptions(fichiers, options('CPU')); });
      });
    }).then(function (d) {
      detecteur = d;
      etat('');
      if (urlActuelle) return chargerImage(urlActuelle);
    }).catch(function (e) {
      console.error(e);
      promesseDetecteur = null;
      etat(T.echecChargement);
      if (fenetre) majPhoto();
    });
    return promesseDetecteur;
  }
  function extraire(resultat) {
    var visage = resultat.faceLandmarks && resultat.faceLandmarks[0];
    repere = visage ? visage.map(function (p) { return { x: p.x, y: p.y }; }) : null;
    points = repere ? lesLevres() : null;
  }
  function lesLevres() { return LEVRES_EXT.concat(LEVRES_INT).map(function (i) { return { x: repere[i].x, y: repere[i].y }; }); }

  // ---------- contour calé sur le vrai bord ----------
  // Le repérage du visage se trompe souvent de quelques pixels, surtout sur une moue ou avec une barbe : il pose le
  // contour trop haut ou trop bas (essai de Jimmy, 18 octobre 2026). Chaque point du contour glisse donc le long de sa
  // perpendiculaire jusqu'au vrai bord de la lèvre : là où la rougeur chute vers la peau ou la barbe, et, côté bouche,
  // vers les dents ou l'ombre. Un point ne bouge que si ce bord est net et proche; sinon il reste où le repérage l'a
  // mis. C'est ce qui protège les lèvres pâles avec l'âge : le même jour, une correction par classes de couleur
  // effaçait la lèvre du haut.
  function adoucir(t, w, h, passes) {
    var u = new Float32Array(t.length);
    for (var n = 0; n < passes; n++) {
      for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
        var o = y * w + x; u[o] = (t[o] + t[o - (x > 0)] + t[o + (x < w - 1)]) / 3;
      }
      for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
        o = y * w + x; t[o] = (u[o] + u[o - (y > 0) * w] + u[o + (y < h - 1) * w]) / 3;
      }
    }
  }
  // Essayé le même jour et retiré : apprendre sur chaque photo un mélange rougeur et clarté. Il recalait de travers des
  // contours justes; la rougeur seule rattrape la plupart des décalages sans toucher aux bons contours.
  function affinerContour(pts) {
    var w = toile.width, h = toile.height, b = boite(pts), W = (b.x1 - b.x0) * w;
    if (W < 40) return pts;
    var marge = Math.ceil(W * 0.15);
    var x0 = Math.max(0, Math.floor(b.x0 * w) - marge), y0 = Math.max(0, Math.floor(b.y0 * h) - marge);
    var bw = Math.min(w, Math.ceil(b.x1 * w) + marge) - x0, bh = Math.min(h, Math.ceil(b.y1 * h) + marge) - y0;
    var d = ctx.getImageData(x0, y0, bw, bh).data;
    // deux cartes adoucies : la rougeur (log R/G, en lumière linéaire) et la clarté (log Y)
    var rouge = new Float32Array(bw * bh), clair = new Float32Array(bw * bh), k, i;
    for (k = 0, i = 0; k < rouge.length; k++, i += 4) {
      var r = VERS_LIN[d[i]], g = VERS_LIN[d[i + 1]], bl = VERS_LIN[d[i + 2]];
      rouge[k] = Math.log((r + 0.004) / (g + 0.004)); clair[k] = Math.log(lumLin(r, g, bl) + 0.004);
    }
    var passes = Math.max(1, Math.round(W * 0.008));
    adoucir(rouge, bw, bh, passes); adoucir(clair, bw, bh, passes);
    function lire(t, x, y) {
      x -= x0; y -= y0;
      if (!(x >= 0 && y >= 0 && x < bw - 1 && y < bh - 1)) return NaN;
      var xi = x | 0, yi = y | 0, fx = x - xi, fy = y - yi, o = yi * bw + xi;
      return (t[o] * (1 - fx) + t[o + 1] * fx) * (1 - fy) + (t[o + bw] * (1 - fx) + t[o + bw + 1] * fx) * fy;
    }
    var P = pts.map(function (p) { return { x: p.x * w, y: p.y * h }; });
    var cx = 0, cy = 0;
    for (k = 0; k < NB_EXT; k++) { cx += P[k].x / NB_EXT; cy += P[k].y / NB_EXT; }
    var pas = Math.max(0.5, W * 0.004), dh = Math.max(1, W * 0.012);
    var bilan = [], nettete = [];
    function normale(debut, n, j, interieur) {
      var a = P[debut + (j + n - 1) % n], c = P[debut + (j + 1) % n], p = P[debut + j];
      var L = Math.hypot(c.x - a.x, c.y - a.y) || 1, nx = (c.y - a.y) / L, ny = -(c.x - a.x) / L;
      // la normale sort de la lèvre : vers l'extérieur pour le contour extérieur, vers l'ouverture pour l'intérieur
      if (((cx - p.x) * nx + (cy - p.y) * ny > 0) !== interieur) { nx = -nx; ny = -ny; }
      return [nx, ny];
    }
    function chuteEn(x, y, n) { return (lire(rouge, x - n[0] * dh, y - n[1] * dh) - lire(rouge, x + n[0] * dh, y + n[1] * dh)) / (2 * dh); }
    // 1. toute la bouche d'abord : le décalage et l'étirement qui posent le contour extérieur sur les bords les plus nets.
    //    C'est l'erreur typique du repérage (contour entier trop haut, trop petit sur une moue), que des points qui ne
    //    glissent que sur leur perpendiculaire ne peuvent pas rattraper sur les côtés.
    var N0 = [], j0;
    for (j0 = 0; j0 < NB_EXT; j0++) N0.push(normale(0, NB_EXT, j0, false));
    function energie(dx, dy, sx, sy) {
      var e = 0;
      for (var j = 0; j < NB_EXT; j++) {
        var v = chuteEn(cx + sx * (P[j].x - cx) + dx, cy + sy * (P[j].y - cy) + dy, N0[j]);
        if (v === v) e += Math.max(-0.5 / W, Math.min(3 / W, v));
      }
      return e;
    }
    var depart = energie(0, 0, 1, 1), choix = [0, 0, 1, 1], meilleure = depart;
    for (var gy = -0.08; gy <= 0.0801; gy += 0.01) for (var gx = -0.04; gx <= 0.0401; gx += 0.01)
      for (var gsy = 0.9; gsy <= 1.2001; gsy += 0.05) for (var gsx = 0.95; gsx <= 1.1001; gsx += 0.05) {
        var e = energie(gx * W, gy * W, gsx, gsy);
        if (e <= 0) continue;
        // préférence pour les petits mouvements : un bord lointain doit être nettement meilleur pour l'emporter
        e *= Math.exp(-(gx * gx + gy * gy) / (2 * 0.05 * 0.05)) * Math.exp(-((gsx - 1) * (gsx - 1) + (gsy - 1) * (gsy - 1)) / (2 * 0.1 * 0.1));
        if (e > meilleure) { meilleure = e; choix = [gx * W, gy * W, gsx, gsy]; }
      }
    if (meilleure > 1.1 * Math.max(depart, 0)) {
      P.forEach(function (p) { p.x = cx + choix[2] * (p.x - cx) + choix[0]; p.y = cy + choix[3] * (p.y - cy) + choix[1]; });
      cx += choix[0]; cy += choix[1];
    } else choix = [0, 0, 1, 1];
    // 2. puis chaque point, sur sa perpendiculaire
    function glisser(debut, n, portee, sigma, interieur, fixes) {
      var depl = [], forces = [], normales = [];
      for (var j = 0; j < n; j++) {
        var p = P[debut + j], nn = normale(debut, n, j, interieur), nx = nn[0], ny = nn[1];
        var meilleur = 0, tMeilleur = 0;
        for (var t = -portee; t <= portee; t += pas) {
          var xa = p.x + nx * (t - dh), ya = p.y + ny * (t - dh), xb = p.x + nx * (t + dh), yb = p.y + ny * (t + dh);
          var chute = interieur
            ? Math.max((lire(rouge, xa, ya) - lire(rouge, xb, yb)) / (2 * dh), 0.5 * (lire(clair, xa, ya) - lire(clair, xb, yb)) / (2 * dh))
            : (lire(rouge, xa, ya) - lire(rouge, xb, yb)) / (2 * dh);
          if (!(chute > 0)) continue;
          var score = chute * Math.exp(-t * t / (2 * sigma * sigma));
          if (score > meilleur) { meilleur = score; tMeilleur = t; }
        }
        depl.push(tMeilleur); forces.push(meilleur); normales.push([nx, ny]);
      }
      // un point ne bouge que si son bord est net : au moins le tiers du bord le plus net du contour, et au-dessus du bruit
      var plusNet = Math.max.apply(null, forces), seuil = Math.max(plusNet / 3, SEUIL_BORD / W);
      forces.forEach(function (f) { nettete.push(Math.round(f * W * 100) / 100); });
      depl = depl.map(function (v, j) { return forces[j] >= seuil && fixes.indexOf(j) < 0 ? v : 0; });
      // lissage le long du contour : médiane de trois, puis moyenne pondérée, pour garder une courbe ronde
      var med = depl.map(function (v, j) { var t3 = [depl[(j + n - 1) % n], v, depl[(j + 1) % n]].sort(function (x, y) { return x - y; }); return t3[1]; });
      for (j = 0; j < n; j++) {
        var lisse = 0.25 * med[(j + n - 1) % n] + 0.5 * med[j] + 0.25 * med[(j + 1) % n];
        if (fixes.indexOf(j) >= 0) lisse = 0;
        else if (j === 0 || j === n / 2) lisse *= 0.5;   // les coins : direction incertaine, demi-mouvement
        lisse = Math.max(-portee, Math.min(portee, lisse));
        P[debut + j].x += normales[j][0] * lisse; P[debut + j].y += normales[j][1] * lisse;
        bilan.push(Math.round(lisse / W * 1000) / 1000);
      }
    }
    glisser(0, NB_EXT, W * 0.06, W * 0.03, false, []);
    // côté bouche, seulement si elle est ouverte; les coins intérieurs suivent les coins extérieurs
    var ouverture = Math.hypot(P[NB_EXT + 5].x - P[NB_EXT + 15].x, P[NB_EXT + 5].y - P[NB_EXT + 15].y);
    if (ouverture > W * 0.03) glisser(NB_EXT, NB_EXT, W * 0.05, W * 0.025, true, [0, NB_EXT / 2]);
    // garde-fou : une surface qui change trop veut dire un bord mal lu; on garde alors le repérage tel quel
    function aire(debut) { var s2 = 0; for (var j = 0; j < NB_EXT; j++) { var p = P[debut + j], q = P[debut + (j + 1) % NB_EXT]; s2 += p.x * q.y - q.x * p.y; } return Math.abs(s2) / 2; }
    var avant = 0; for (k = 0; k < NB_EXT; k++) { var p0 = pts[k], q0 = pts[(k + 1) % NB_EXT]; avant += (p0.x * w) * (q0.y * h) - (q0.x * w) * (p0.y * h); }
    var rapport = aire(0) / (Math.abs(avant) / 2);
    if (window.__aevMesures) window.__aevMesures.push({ affinage: { rapport: rapport, deplacements: bilan, nettete: nettete, global: choix.map(function (v, k) { return k < 2 ? Math.round(v / W * 1000) / 1000 : Math.round(v * 100) / 100; }) } });
    if (!(rapport > 0.7 && rapport < 1.45)) return pts;
    return P.map(function (p) { return { x: p.x / w, y: p.y / h }; });
  }

  // ---------- mesure de la lumière ----------
  function disques(img, w, h, ids, r) {
    var R = [], G = [], B = [];
    ids.forEach(function (i) {
      var cx = repere[i].x * w, cy = repere[i].y * h;
      for (var y = Math.max(0, Math.round(cy - r)); y <= Math.min(h - 1, Math.round(cy + r)); y++)
        for (var x = Math.max(0, Math.round(cx - r)); x <= Math.min(w - 1, Math.round(cx + r)); x++) {
          if ((x - cx) * (x - cx) + (y - cy) * (y - cy) > r * r) continue;
          var o = (y * w + x) * 4; R.push(VERS_LIN[img[o]]); G.push(VERS_LIN[img[o + 1]]); B.push(VERS_LIN[img[o + 2]]);
        }
    });
    return R.length ? [mediane(R), mediane(G), mediane(B)] : null;
  }
  function lumiereDePeau(p, studio) {
    // écart entre la peau de la cliente et celle du studio du produit : en intensité, puis en couleur (bornée, pour qu'une
    // mesure ratée ne vire jamais la teinte au vert ou au bleu)
    var Yp = lumLin(p[0], p[1], p[2]), Ys = lumLin(studio[0], studio[1], studio[2]);
    if (!(Yp > 0)) return null;
    var e = Math.min(2.5, Math.max(0.2, Math.pow(Yp / Ys, SUIVI_EXPO)));
    var c = [0, 1, 2].map(function (k) { return Math.min(1.6, Math.max(0.6, Math.pow((p[k] / Yp) / (studio[k] / Ys), SUIVI_COULEUR))); });
    var Yc = lumLin(c[0], c[1], c[2]);
    return c.map(function (v) { return e * v / Yc; });
  }
  function estimerLumiere() {
    // à appeler quand la toile montre la photo sans teinte
    if (!repere || repere.length < 468) return null;
    var w = toile.width, h = toile.height, img = ctx.getImageData(0, 0, w, h).data;
    var r = 0.035 * Math.hypot((repere[454].x - repere[234].x) * w, (repere[454].y - repere[234].y) * h);
    var peau = disques(img, w, h, PEAU_BOUCHE, r);
    if (window.__aevMesures) window.__aevMesures.push({ peau: peau, repere: repere, w: w, h: h });
    return peau;
  }

  // ---------- rendu ----------
  function trace(c, pts, w, h, dx) {
    dx = dx || 0;
    var P = pts.map(function (p) { return [p.x * w + dx, p.y * h]; }), n = P.length;
    c.moveTo((P[n - 1][0] + P[0][0]) / 2, (P[n - 1][1] + P[0][1]) / 2);
    for (var i = 0; i < n; i++) {
      var s = P[(i + 1) % n];
      c.quadraticCurveTo(P[i][0], P[i][1], (P[i][0] + s[0]) / 2, (P[i][1] + s[1]) / 2);
    }
    c.closePath();
  }
  function lum(r, g, b) { return 0.2126 * r + 0.7152 * g + 0.0722 * b; }

  // ---------- contour ----------
  // La teinte suit le contour du repérage du visage, avec un bord net (1,4 % de la largeur de la bouche) : un bord flou
  // fait « retouché ». Essayé le 18 octobre 2026 : corriger ce contour par la couleur de la photo. Abandonné : la lèvre
  // du haut, souvent pâle avec l'âge, ressemble à la peau ou aux dents, et la teinte s'effaçait par endroits. Quand le
  // contour se trompe, la cliente l'ajuste à la main.
  function couverture(ext, int, w, h, bx, by, bw, bh, L) {
    // forme adoucie : dessinée hors champ, on garde son ombre floue (Safari ignore le filtre flou du canvas)
    var hors = w + 50;
    mctx.clearRect(0, 0, w, h);
    mctx.save();
    mctx.shadowColor = '#fff'; mctx.shadowBlur = Math.max(1, L * 0.014); mctx.shadowOffsetX = hors;
    mctx.beginPath(); trace(mctx, ext, w, h, -hors); trace(mctx, int, w, h, -hors);
    mctx.fillStyle = '#fff'; mctx.fill('evenodd');
    mctx.restore();
    var m = mctx.getImageData(bx, by, bw, bh).data, alpha = new Float32Array(bw * bh);
    for (var j = 0; j < alpha.length; j++) alpha[j] = m[j * 4 + 3] / 255;
    return alpha;
  }

  function appliquerTeinte(w, h) {
    var ext = points.slice(0, NB_EXT), int = points.slice(NB_EXT), b = boite(points), L = (b.x1 - b.x0) * w;
    var marge = Math.ceil(Math.max(4, L * 0.06));
    var bx = Math.max(0, Math.floor(b.x0 * w) - marge), by = Math.max(0, Math.floor(b.y0 * h) - marge);
    var bw = Math.min(w, Math.ceil(b.x1 * w) + marge) - bx, bh = Math.min(h, Math.ceil(b.y1 * h) + marge) - by;
    if (bw <= 2 || bh <= 2) return;
    if (masque.width !== w || masque.height !== h) { masque.width = w; masque.height = h; }
    var img = ctx.getImageData(bx, by, bw, bh), px = img.data;
    var cv = couverture(ext, int, w, h, bx, by, bw, bh, L);
    var Ys = [], autour = [[], [], []], i, a;
    for (i = 0; i < px.length; i += 4) {
      a = cv[i >> 2];
      if (a > 0.6) Ys.push(lumLin(VERS_LIN[px[i]], VERS_LIN[px[i + 1]], VERS_LIN[px[i + 2]]));
      else if (a < 0.01 && !peauCliente) { autour[0].push(VERS_LIN[px[i]]); autour[1].push(VERS_LIN[px[i + 1]]); autour[2].push(VERS_LIN[px[i + 2]]); }
    }
    if (Ys.length < 10) return;
    // lèvres placées à la main, sans visage détecté : la peau qui entoure le contour donne la lumière
    var peau = peauCliente || (autour[0].length ? autour.map(mediane) : null);
    var I = (peau && lumiereDePeau(peau, teinte.peau || PEAU_STUDIO)) || [1, 1, 1];
    var fini = FINIS[teinte.fini] || FINIS.mat;
    Ys.sort(function (p, q) { return p - q; });
    var p10 = Math.max(1e-5, Ys[Math.floor(Ys.length * 0.1)]), p50 = Math.max(1e-5, Ys[Ys.length >> 1]);
    var p90 = Ys[Math.floor(Ys.length * 0.9)], p98 = Ys[Math.floor(Ys.length * 0.98)];
    // le relief de la cliente est ramené à celui de la teinte portée : ses plis restent, sa brillance suit le fini
    var bas = Math.min(2.5, Math.max(0.3, Math.log(fini.relief[0]) / Math.min(-0.05, Math.log(p10 / p50))));
    var haut = Math.min(2.5, Math.max(0.3, Math.log(fini.relief[1]) / Math.max(0.05, Math.log(p90 / p50))));
    var n = parseInt(teinte.portee.slice(1), 16);
    var C = [VERS_LIN[n >> 16] * I[0], VERS_LIN[(n >> 8) & 255] * I[1], VERS_LIN[n & 255] * I[2]];
    // reflet posé : une tache douce au centre de la lèvre du bas, là où la lumière d'en haut accroche un fini qui brille,
    // pour que le fini se voie même quand la lèvre d'origine est mate sur la photo
    var bh0 = points[NB_EXT + 5], bb0 = points[5], larg = (b.x1 - b.x0) * w;
    var rx = (bh0.x + 0.42 * (bb0.x - bh0.x)) * w - bx, ry = (bh0.y + 0.42 * (bb0.y - bh0.y)) * h - by;
    var ax = Math.max(2, larg * 0.16), ay = Math.max(1.5, Math.hypot((bb0.x - bh0.x) * w, (bb0.y - bh0.y) * h) * 0.22);
    var seuilReflet = Math.log(Math.max(1.12, Math.min(p90 / p50, 1.6))), etendue = Math.max(0.05, Math.log(Math.max(p98 / p50, 1.3)) - seuilReflet);
    // part de la couleur sur la lèvre : opaque pour les rouges, partielle pour un gloss ou une huile (la lèvre transparaît)
    var couv = teinte.couv != null ? teinte.couv : COUVRANCE;
    var nacre = teinte.nacre != null ? teinte.nacre : fini.nacre, eclat = [1, 1, 1];
    if (teinte.eclat) {
      // couleur des paillettes (dorées, argentées...), ramenée à une clarté proche du blanc, avec un peu de la couleur
      // du gloss qui les enrobe
      var ne = parseInt(teinte.eclat.slice(1), 16), el = [VERS_LIN[ne >> 16], VERS_LIN[(ne >> 8) & 255], VERS_LIN[ne & 255]];
      var cm = Math.max(C[0], C[1], C[2], 1e-3), em = Math.max(el[0], el[1], el[2], 1e-3);
      eclat = el.map(function (v, k) { return 0.75 * v / em + 0.25 * C[k] / cm; });
    }
    var tc = fini.teinteReflet || 0, cmax = Math.max(C[0], C[1], C[2], 1e-3);
    var tr = C.map(function (v) { return 1 - tc + tc * v / cmax; });
    var geo = fini.reflet ? geometrie(w, h, bx, bw) : null;
    var mouille = fini.mouille ? reflets(w, h, bx, by, bw, bh, cv, px, L, geo, fini) : null;
    for (var y = 0; y < bh; y++) {
      for (var x = 0; x < bw; x++) {
        i = (y * bw + x) * 4;
        a = cv[i >> 2];
        if (a <= 0.01) continue;
        if (comparer && (bx + x) / w < coupe) continue;
        var r = VERS_LIN[px[i]], g = VERS_LIN[px[i + 1]], bl = VERS_LIN[px[i + 2]];
        var lf = Math.log(Math.max(1e-5, lumLin(r, g, bl)) / p50);
        var f = Math.exp(Math.max(-1.6, Math.min(0.6, lf * (lf < 0 ? bas : haut))));
        var R = C[0] * f, G = C[1] * f, B = C[2] * f, sp = 0, spn = 0;
        if (fini.reflet) {
          var dx = (x - rx) / ax, dy = (y - ry) / ay;
          var tache = Math.exp(-(dx * dx + dy * dy) * 1.5) * Math.min(1, Math.max(0, f));
          var photo = Math.min(1, Math.max(0, (lf - seuilReflet) / etendue)) * interieur(geo, x, by + y);
          sp = fini.reflet * Math.max(photo * photo, (mouille ? 0 : fini.tache != null ? fini.tache : 0.55) * tache * tache);
          if (mouille) sp = Math.max(sp, fini.mouille * mouille[i >> 2]);
        }
        if (nacre) {
          // grain de nacre : des points fixes sur la photo, plus visibles là où la lèvre est éclairée. Les paillettes
          // mesurées sur une photo (gloss) sont plus rares et plus vives que la nacre fine des rouges.
          var gr;
          if (teinte.nacre != null) {
            // paillettes d'un gloss : grains fins, d'autant plus nombreux que la teinte en porte, et qui ne s'allument
            // vraiment que là où la lèvre prend la lumière
            gr = Math.sin((bx + x) * 12.9898 + (by + y) * 78.233) * 43758.5453; gr -= Math.floor(gr);
            var seuilN = 0.972 - 0.04 * nacre, fl = Math.min(1.5, f);
            spn = Math.pow(Math.max(0, gr - seuilN) / (1 - seuilN), 1.5) * fl * fl * (0.35 + 0.5 * nacre);
          } else {
            gr = Math.sin((bx + x) * 12.9898 + (by + y) * 78.233) * 43758.5453; gr -= Math.floor(gr);
            spn = nacre * Math.max(0, gr - 0.86) / 0.14 * Math.min(1.2, f) * 0.35;
          }
        }
        var ac = a * couv, al = a * COUVRANCE;
        // la couleur se mêle à la lèvre selon sa couverture; la lumière réfléchie s'ajoute par-dessus, blanche (un peu
        // teintée de la couleur du produit pour un gloss : son reflet traverse la couche colorée)
        px[i] = ecran(r * (1 - ac) + R * ac + (sp * tr[0] + spn * eclat[0]) * 0.85 * I[0] * al);
        px[i + 1] = ecran(g * (1 - ac) + G * ac + (sp * tr[1] + spn * eclat[1]) * 0.85 * I[1] * al);
        px[i + 2] = ecran(bl * (1 - ac) + B * ac + (sp * tr[2] + spn * eclat[2]) * 0.85 * I[2] * al);
      }
    }
    ctx.putImageData(img, bx, by);
  }

  // ---------- reflets mouillés (gloss, huile, satiné) ----------
  // Une lèvre bombée renvoie la lumière d'en haut à deux endroits : le milieu de la lèvre du bas, un peu au-dessus de sa
  // moitié, et les deux sommets de la lèvre du haut. Le reflet y suit les plis de la lèvre de la cliente (un pli sombre
  // le coupe), avec un bord net : c'est ce qui fait « mouillé » plutôt que « flou ». Rend une carte 0..1 par pixel.
  function chemin(indices) { return indices.map(function (k) { return points[k]; }); }
  function profil(pts, w, h, bx, bw) {
    var col = new Float32Array(bw).fill(NaN);
    for (var k = 0; k + 1 < pts.length; k++) {
      var x0 = pts[k].x * w - bx, x1 = pts[k + 1].x * w - bx, y0 = pts[k].y * h, y1 = pts[k + 1].y * h, t;
      if (x1 < x0) { t = x0; x0 = x1; x1 = t; t = y0; y0 = y1; y1 = t; }
      for (var x = Math.max(0, Math.ceil(x0)); x <= Math.min(bw - 1, Math.floor(x1)); x++)
        col[x] = x1 - x0 > 1e-6 ? y0 + (y1 - y0) * (x - x0) / (x1 - x0) : y0;
    }
    return col;
  }
  function gauss(t, m, s) { var d = (t - m) / s; return Math.exp(-0.5 * d * d); }
  // Les quatre bords de la bouche, colonne par colonne : haut et bas du contour extérieur, haut et bas de l'ouverture
  function geometrie(w, h, bx, bw) {
    var E = NB_EXT, g = {
      hautExt: profil(chemin([10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 0]), w, h, bx, bw),
      basExt: profil(chemin([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]), w, h, bx, bw),
      hautInt: profil(chemin([E + 10, E + 11, E + 12, E + 13, E + 14, E + 15, E + 16, E + 17, E + 18, E + 19, E]), w, h, bx, bw),
      basInt: profil(chemin([E, E + 1, E + 2, E + 3, E + 4, E + 5, E + 6, E + 7, E + 8, E + 9, E + 10]), w, h, bx, bw),
      xG: points[0].x * w - bx, xD: points[10].x * w - bx
    };
    if (g.xD < g.xG) { var t = g.xG; g.xG = g.xD; g.xD = t; }
    return g;
  }
  // Loin des bords, 1; sur le bord extérieur de la lèvre ou dans les coins, 0. Un reflet tiré de la photo ne s'allume
  // pas sur le bord : la peau juste au-dessus de la lèvre du haut est plus claire que la lèvre, et elle faisait des
  // petits reflets blancs sur son contour (capture de Marilyn, 19 octobre 2026, rouge Glossy).
  function interieur(g, x, yy) {
    var hE = g.hautExt[x], hI = g.hautInt[x], bI = g.basInt[x], bE = g.basExt[x];
    if (!(hE === hE && hI === hI && bI === bI && bE === bE)) return 0;
    var u = (x - g.xG) / Math.max(1, g.xD - g.xG), v, k;
    if (yy < (hI + bI) / 2) { v = (yy - hE) / Math.max(1, hI - hE); k = (v - 0.22) / 0.2; }
    else { v = (yy - bI) / Math.max(1, bE - bI); k = (0.85 - v) / 0.2; }
    k = Math.min(1, Math.max(0, k)) * Math.min(1, Math.max(0, (u - 0.05) / 0.1)) * Math.min(1, Math.max(0, (0.95 - u) / 0.1));
    return k * k * (3 - 2 * k);
  }
  // hautLevre : part des reflets de la lèvre du haut (1 pour un gloss); bord : les reflets restent loin du bord extérieur
  function reflets(w, h, bx, by, bw, bh, cv, px, L, geo, fini) {
    var partHaut = fini.hautLevre != null ? fini.hautLevre : 1;
    var k, j, hautExt = geo.hautExt, basExt = geo.basExt, hautInt = geo.hautInt, basInt = geo.basInt, xG = geo.xG, xD = geo.xD;
    // le modelé de la lèvre à moyenne échelle (les plis y restent visibles, le grain de la peau non), en écarts types
    // au-dessus de sa moyenne : un reflet de gloss se forme là où la lèvre est déjà la plus claire, avec un bord net
    var n = bw * bh, brut = new Float32Array(n), moyen, cpt = 0, m1 = 0, q1 = 0, c2 = 0, m2 = 0, q2 = 0;
    for (k = 0; k < n; k++) brut[k] = Math.log(lumLin(VERS_LIN[px[k * 4]], VERS_LIN[px[k * 4 + 1]], VERS_LIN[px[k * 4 + 2]]) + 1e-4);
    moyen = new Float32Array(brut); adoucir(moyen, bw, bh, Math.max(1, Math.round(L * 0.006)));
    // les plis d'une lèvre sont verticaux : écart de la clarté à sa moyenne de gauche à droite, étiré de haut en bas
    var plis = new Float32Array(n), tmp = new Float32Array(n), rx = Math.max(1, Math.round(L * 0.006)), ry = Math.max(1, Math.round(L * 0.01));
    for (var y0 = 0; y0 < bh; y0++) {
      var o = y0 * bw, acc = 0, nb = 0, x0;
      for (x0 = 0; x0 < Math.min(bw, rx); x0++) { acc += brut[o + x0]; nb++; }
      for (x0 = 0; x0 < bw; x0++) {
        if (x0 + rx < bw) { acc += brut[o + x0 + rx]; nb++; }
        if (x0 - rx - 1 >= 0) { acc -= brut[o + x0 - rx - 1]; nb--; }
        tmp[o + x0] = brut[o + x0] - acc / nb;
      }
    }
    for (x0 = 0; x0 < bw; x0++) {
      acc = 0; nb = 0;
      for (y0 = 0; y0 < Math.min(bh, ry); y0++) { acc += tmp[y0 * bw + x0]; nb++; }
      for (y0 = 0; y0 < bh; y0++) {
        if (y0 + ry < bh) { acc += tmp[(y0 + ry) * bw + x0]; nb++; }
        if (y0 - ry - 1 >= 0) { acc -= tmp[(y0 - ry - 1) * bw + x0]; nb--; }
        plis[y0 * bw + x0] = acc / nb;
      }
    }
    var carte = new Float32Array(n), env = new Float32Array(n);
    for (var y = 0; y < bh; y++) {
      var yy = by + y;
      for (var x = 0; x < bw; x++) {
        k = y * bw + x;
        if (cv[k] <= 0.01) continue;
        var hE = hautExt[x], hI = hautInt[x], bI = basInt[x], bE = basExt[x];
        if (!(hE === hE && hI === hI && bI === bI && bE === bE)) continue;
        var u = (x - xG) / Math.max(1, xD - xG), g, v;
        if (yy < (hI + bI) / 2) {
          v = (yy - hE) / Math.max(1, hI - hE);           // 0 : bord du haut; 1 : bord de la bouche
          g = 0.9 * partHaut * Math.max(gauss(u, 0.36, 0.1), gauss(u, 0.64, 0.1)) * gauss(v, 0.32, 0.16);
        } else {
          v = (yy - bI) / Math.max(1, bE - bI);           // 0 : bord de la bouche; 1 : bord du bas
          g = gauss(u, 0.5, 0.22) * gauss(v, 0.36, 0.15);
        }
        g *= Math.min(1, Math.max(0, (u - 0.06) / 0.12)) * Math.min(1, Math.max(0, (0.94 - u) / 0.12));
        env[k] = g;
        if (g > 0.15 && cv[k] > 0.6) {
          m1 += moyen[k] * g; q1 += moyen[k] * moyen[k] * g; cpt += g;
          var d = plis[k]; m2 += d; q2 += d * d; c2++;
        }
      }
    }
    cpt = Math.max(1e-6, cpt); m1 /= cpt; c2 = Math.max(1, c2); m2 /= c2;
    var e1 = Math.sqrt(Math.max(1e-6, q1 / cpt - m1 * m1)), e2 = Math.sqrt(Math.max(1e-6, q2 / c2 - m2 * m2));
    if (fini.stries) {
      // gloss et huile : une lueur douce là où la lèvre bombée prend la lumière, et par-dessus de fines stries claires
      // sur les crêtes entre les plis, comme sur les photos de la boutique. Plus de grand aplat blanc au bord découpé
      // (« effet cartoon », Jimmy, 22 octobre 2026).
      for (k = 0; k < n; k++) {
        if (!env[k]) continue;
        // les plis comptent en vraie clarté (au moins 3 %), pas en écarts types : une photo floue n'a presque pas de
        // plis visibles, et les mesurer quand même dessinait des tirets réguliers
        var zs = (moyen[k] - m1) / e1, ps = (plis[k] - m2) / Math.max(e2, 0.03), e = env[k];
        var lumiere = Math.min(1, Math.max(0, (zs + 1) / 2));
        var voile = e * e * (0.45 + 0.55 * lumiere);
        var strie = Math.min(1, Math.max(0, ps / 1.3));
        strie = strie * Math.min(1, e * 1.4) * (0.3 + 0.7 * lumiere);
        var ss = Math.min(1, fini.stries[0] * voile + fini.stries[1] * strie * strie);
        if (fini.bord) ss *= interieur(geo, k % bw, by + ((k / bw) | 0));
        carte[k] = ss;
      }
      return carte;
    }
    for (k = 0; k < n; k++) {
      if (!env[k]) continue;
      // plus l'enveloppe est forte, plus le seuil est bas : le reflet naît au cœur de la zone et s'arrête net; un pli
      // fin plus sombre que son entourage le coupe, ce qui le brise en stries comme sur une vraie lèvre
      var z = (moyen[k] - m1) / e1, seuil = 1.25 - 0.9 * env[k];
      var pli = (plis[k] - m2) / e2;
      var s = Math.min(1, Math.max(0, (z - seuil) / 0.35)) * Math.min(1, env[k] * 2.2) * Math.min(1, Math.max(0, (pli + 1.3) / 0.8));
      if (fini.bord) s *= interieur(geo, k % bw, by + ((k / bw) | 0));
      carte[k] = s * s * (3 - 2 * s);
    }
    return carte;
  }
  function dessiner() {
    if (!source) return;
    var w = toile.width, h = toile.height;
    ctx.drawImage(source, 0, 0, w, h);
    if (teinte.portee && points) appliquerTeinte(w, h);
    if (ajustement && points) {
      var e = echelle().e * vue.Z;
      ctx.save();
      ctx.lineWidth = 1.5 / e; ctx.strokeStyle = 'rgba(255,255,255,.9)'; ctx.setLineDash([4 / e, 3 / e]);
      ctx.beginPath(); trace(ctx, points.slice(0, NB_EXT), w, h); ctx.stroke();
      ctx.beginPath(); trace(ctx, points.slice(NB_EXT), w, h); ctx.stroke();
      ctx.restore();
    }
  }

  // ---------- avant / après ----------
  function suivre(e) {
    var r = toile.getBoundingClientRect(), s = Math.min(r.width / toile.width, r.height / toile.height);
    var largeur = toile.width * s, gauche = r.left + (r.width - largeur) / 2;
    coupe = Math.min(1, Math.max(0, (e.clientX - gauche) / largeur));
    var sr = $('.aev__scene').getBoundingClientRect();
    $('.aev__poignee').style.left = ((gauche - sr.left) + coupe * largeur) / sr.width * 100 + '%';
    dessiner();
  }

  // ---------- sources ----------
  function charge(url) {
    return new Promise(function (ok, ko) { var img = new Image(); img.crossOrigin = 'anonymous'; img.onload = function () { ok(img); }; img.onerror = ko; img.src = url; });
  }
  function tailler(sw, sh) {
    var e = Math.min(1, 1280 / Math.max(sw, sh));
    toile.width = Math.round(sw * e); toile.height = Math.round(sh * e);
    $('.aev__scene').style.aspectRatio = toile.width + ' / ' + toile.height;
    $('.aev__scene').style.setProperty('--aev-ratio', String(toile.width / toile.height));
    $('.aev__vide').hidden = true;
    loger();
  }
  function chargerImage(url) {
    urlActuelle = url;
    return charge(url).then(function (img) {
      if (url !== urlActuelle || !fenetre) return;
      if (ajustement) quitterAjustement();
      source = img; points = null; pointsDetectes = null; repere = null; peauCliente = null;
      tailler(img.naturalWidth, img.naturalHeight);
      ctx.drawImage(img, 0, 0, toile.width, toile.height);
      majPhoto();
      if (!detecteur) { if (!promesseDetecteur) preparerDetecteur(); return; }
      extraire(detecteur.detect(img));
      if (!points && origine && origine.url === url) {
        // recadrage trop serré pour voir un visage : on cherche sur la photo entière, puis on ramène au cadre
        var r = detecteur.detect(origine.img).faceLandmarks;
        var iw = origine.img.naturalWidth || origine.img.width, ih = origine.img.naturalHeight || origine.img.height;
        if (r && r[0]) {
          repere = r[0].map(function (p) { return { x: (p.x * iw - origine.sx) / origine.sw, y: (p.y * ih - origine.sy) / origine.sh }; });
          points = lesLevres();
        }
      }
      if (points) {
        var avant = copie(points);
        points = affinerContour(points);
        if (window.__aevMesures) window.__aevMesures.push({ contourAvant: avant, contourApres: copie(points), w: toile.width, h: toile.height });
      }
      if (points) pointsDetectes = copie(points);
      peauCliente = estimerLumiere();
      majPhoto();
      etat(points ? '' : T.aucunVisage);
      dessiner();
    }).catch(function () { etat(T.imageIllisible); });
  }

  // ---------- selfie ----------
  // La caméra sert seulement à prendre la photo : la teinte se pose ensuite sur la photo fixe, jamais en direct
  // (Jimmy, 18 octobre 2026 : on maîtrise d'abord le mode photo). L'aperçu est en miroir, comme un miroir de salle de
  // bain, et la photo aussi : la cliente se retrouve telle qu'elle s'est vue.
  var flux = null;
  // L'aperçu couvre tout l'écran, comme l'appareil photo ou FaceTime (demande de Jimmy, 18 octobre 2026) : sur un
  // téléphone, couvrir l'écran en hauteur rogne déjà les côtés de la caméra avant, qui est plus large que le selfie natif.
  function ouvrirSelfie() {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      etat(T.cameraAbsente); return;
    }
    var vue = $('.aev__selfie'), video = vue.querySelector('video'), prendre = $('.aev__selfie-prendre');
    etat('');
    vue.hidden = false; fenetre.classList.add('aev--recadre'); prendre.disabled = true;
    video.muted = true; video.setAttribute('playsinline', '');
    navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user', width: { ideal: 1920 }, height: { ideal: 1440 } }, audio: false })
      .then(function (f) {
        if (vue.hidden) { f.getTracks().forEach(function (t) { t.stop(); }); return; }   // annulé pendant la demande d'autorisation
        flux = f; video.srcObject = f;
        return video.play();
      })
      .then(function () { if (flux) prendre.disabled = false; })
      .catch(function () {
        fermerSelfie();
        etat(T.cameraRefusee);
      });
  }
  function barreApercu(cacher) {
    // La barre « Draft » de l'aperçu Shopify (#PBarNextFrameWrapper, absente du site en ligne) passe par-dessus la page :
    // on la cache tant que la fenêtre d'essai est ouverte, pour qu'elle ne couvre ni le déclencheur du selfie ni
    // « Ajouter au panier », collé au bas de l'écran sur téléphone. Ne jamais mesurer ce qui couvre
    // le bas de l'écran : le 18 octobre 2026, une mesure a pris un cadre invisible de Shopify pour la barre et a remonté
    // le déclencheur au milieu de l'écran sur l'iPhone de Jimmy.
    var b = document.getElementById('PBarNextFrameWrapper');
    if (b) b.style.visibility = cacher ? 'hidden' : '';
  }
  function fermerSelfie() {
    if (flux) { flux.getTracks().forEach(function (t) { t.stop(); }); flux = null; }
    var vue = $('.aev__selfie');
    vue.hidden = true; vue.querySelector('video').srcObject = null;
    fenetre.classList.remove('aev--recadre');
  }
  function prendreSelfie() {
    var video = $('.aev__selfie video'), vw = video.videoWidth, vh = video.videoHeight;
    if (!vw || !vh) return;
    // l'image entière, en miroir; puis ce que la cliente voyait à l'écran (l'image couvre l'écran : les bords sont
    // rognés), et dans cette partie un portrait 3:4, un peu au-dessus du milieu, là où se trouve le visage
    var plein = document.createElement('canvas'); plein.width = vw; plein.height = vh;
    var g = plein.getContext('2d'); g.translate(vw, 0); g.scale(-1, 1); g.drawImage(video, 0, 0, vw, vh);
    var vue = $('.aev__selfie'), k = Math.max(vue.clientWidth / vw, vue.clientHeight / vh);
    var visW = vue.clientWidth / k, visH = vue.clientHeight / k, sw, sh, sx, sy;
    if (visW / visH > 0.75) { sh = visH; sw = sh * 0.75; sx = (vw - sw) / 2; sy = (vh - sh) / 2; }
    else { sw = visW; sh = sw / 0.75; sx = (vw - sw) / 2; sy = (vh - visH) / 2 + (visH - sh) * 0.45; }
    var ow = Math.round(Math.min(sw, 960)), oh = Math.round(ow * 4 / 3);
    var sortie = document.createElement('canvas'); sortie.width = ow; sortie.height = oh;
    sortie.getContext('2d').drawImage(plein, sx, sy, sw, sh, 0, 0, ow, oh);
    var url = sortie.toDataURL('image/jpeg', 0.92);
    origine = { url: url, img: plein, sx: sx, sy: sy, sw: sw, sh: sh };
    // un éclair blanc, comme un vrai déclenchement, puis la photo
    var eclair = $('.aev__selfie-eclair');
    eclair.classList.remove('aev-eclair'); void eclair.offsetWidth; eclair.classList.add('aev-eclair');
    $('.aev__selfie-prendre').disabled = true;
    setTimeout(function () { fermerSelfie(); chargerImage(url); }, 220);
  }

  // ---------- recadrage de la photo ----------
  // Avant d'essayer, la cliente cadre son visage : un doigt déplace la photo, deux doigts (ou la molette) zooment.
  // Le cadre est en portrait 3:4; la photo le couvre toujours en entier.
  var rc = null, rcDoigts = new Map(), rcPince = null, rcGlisse = null;
  var origine = null;   // photo d'origine et zone recadrée, pour retrouver la bouche sur un recadrage trop serré
  function ouvrirRecadrage(url) {
    charge(url).then(function (img) {
      rc = { img: img, url: url };
      fenetre.classList.add('aev--recadre');
      $('.aev__recadre').hidden = false;
      mesurerRecadrage(true);
      dessinerRecadrage();
    }).catch(function () { etat(T.imageIllisible); });
  }
  function fermerRecadrage() {
    $('.aev__recadre').hidden = true;
    fenetre.classList.remove('aev--recadre');
    rcDoigts.clear(); rcPince = null; rcGlisse = null;
  }
  function mesurerRecadrage(depart) {
    var zone = $('.aev__recadre-zone'), c = zone.querySelector('canvas');
    var W = zone.clientWidth, H = zone.clientHeight, dpr = Math.min(3, window.devicePixelRatio || 1);
    c.width = Math.round(W * dpr); c.height = Math.round(H * dpr);
    c.style.width = W + 'px'; c.style.height = H + 'px';
    // marge du bas plus grande : les barres du navigateur (et celle de l'aperçu Shopify) mangent le bas de l'écran
    var H2 = H - 104, fw = Math.min(W - 32, H2 * 3 / 4), fh = fw * 4 / 3;
    var iw = rc.img.naturalWidth, ih = rc.img.naturalHeight;
    rc.W = W; rc.H = H; rc.dpr = dpr; rc.fw = fw; rc.fh = fh; rc.fx = (W - fw) / 2; rc.fy = 16 + (H2 - fh) / 2;
    rc.min = Math.max(fw / iw, fh / ih);
    if (depart) { rc.s = rc.min; rc.x = rc.fx + (fw - iw * rc.s) / 2; rc.y = rc.fy + (fh - ih * rc.s) / 2; }
    bornerRecadrage();
  }
  function bornerRecadrage() {
    var iw = rc.img.naturalWidth, ih = rc.img.naturalHeight;
    rc.s = Math.max(rc.min, Math.min(rc.min * 10, rc.s));
    rc.x = Math.min(rc.fx, Math.max(rc.fx + rc.fw - iw * rc.s, rc.x));
    rc.y = Math.min(rc.fy, Math.max(rc.fy + rc.fh - ih * rc.s, rc.y));
  }
  function dessinerRecadrage() {
    var c = $('.aev__recadre-zone canvas'), g = c.getContext('2d');
    g.setTransform(rc.dpr, 0, 0, rc.dpr, 0, 0);
    g.fillStyle = '#111'; g.fillRect(0, 0, rc.W, rc.H);
    g.drawImage(rc.img, rc.x, rc.y, rc.img.naturalWidth * rc.s, rc.img.naturalHeight * rc.s);
    g.fillStyle = 'rgba(17, 17, 17, .6)';
    g.beginPath(); g.rect(0, 0, rc.W, rc.H); g.rect(rc.fx, rc.fy, rc.fw, rc.fh); g.fill('evenodd');
    g.strokeStyle = 'rgba(255, 255, 255, .9)'; g.lineWidth = 1.5; g.strokeRect(rc.fx, rc.fy, rc.fw, rc.fh);
    g.strokeStyle = 'rgba(255, 255, 255, .25)'; g.lineWidth = 1; g.beginPath();
    for (var t = 1; t < 3; t++) {
      g.moveTo(rc.fx + rc.fw * t / 3, rc.fy); g.lineTo(rc.fx + rc.fw * t / 3, rc.fy + rc.fh);
      g.moveTo(rc.fx, rc.fy + rc.fh * t / 3); g.lineTo(rc.fx + rc.fw, rc.fy + rc.fh * t / 3);
    }
    g.stroke();
  }
  function zoomRecadrage(f, cx, cy) {
    // zoom autour du point (cx, cy) : ce point reste sous le doigt
    var s0 = rc.s; rc.s = Math.max(rc.min, Math.min(rc.min * 10, s0 * f));
    var k = rc.s / s0; rc.x = cx - (cx - rc.x) * k; rc.y = cy - (cy - rc.y) * k;
    bornerRecadrage(); dessinerRecadrage();
  }
  function utiliserRecadrage() {
    var sx = (rc.fx - rc.x) / rc.s, sy = (rc.fy - rc.y) / rc.s, sw = rc.fw / rc.s, sh = rc.fh / rc.s;
    var ow = Math.round(Math.min(sw, 960)), oh = Math.round(ow * 4 / 3);
    var sortie = document.createElement('canvas'); sortie.width = ow; sortie.height = oh;
    sortie.getContext('2d').drawImage(rc.img, sx, sy, sw, sh, 0, 0, ow, oh);
    var url = sortie.toDataURL('image/jpeg', 0.92);
    origine = { url: url, img: rc.img, sx: sx, sy: sy, sw: sw, sh: sh };
    fermerRecadrage();
    chargerImage(url);
  }
  function brancherRecadrage() {
    var zone = $('.aev__recadre-zone');
    function local(ev) { var r = zone.getBoundingClientRect(); return { x: ev.clientX - r.left, y: ev.clientY - r.top }; }
    zone.addEventListener('pointerdown', function (ev) {
      ev.preventDefault(); capturer(zone, ev.pointerId);
      rcDoigts.set(ev.pointerId, local(ev));
      if (rcDoigts.size === 2) {
        var v = Array.from(rcDoigts.values());
        rcGlisse = null;
        rcPince = { d: Math.hypot(v[0].x - v[1].x, v[0].y - v[1].y), mx: (v[0].x + v[1].x) / 2, my: (v[0].y + v[1].y) / 2, s: rc.s, x: rc.x, y: rc.y };
      } else if (rcDoigts.size === 1) { var p = local(ev); rcGlisse = { px: p.x, py: p.y, x: rc.x, y: rc.y }; }
    });
    zone.addEventListener('pointermove', function (ev) {
      if (!rcDoigts.has(ev.pointerId)) return;
      rcDoigts.set(ev.pointerId, local(ev));
      if (rcPince && rcDoigts.size >= 2) {
        var v = Array.from(rcDoigts.values()), mx = (v[0].x + v[1].x) / 2, my = (v[0].y + v[1].y) / 2;
        var s = Math.max(rc.min, Math.min(rc.min * 10, rcPince.s * Math.hypot(v[0].x - v[1].x, v[0].y - v[1].y) / rcPince.d));
        var k = s / rcPince.s;
        rc.s = s; rc.x = mx - (rcPince.mx - rcPince.x) * k; rc.y = my - (rcPince.my - rcPince.y) * k;
        bornerRecadrage(); dessinerRecadrage();
      } else if (rcGlisse) {
        var p = local(ev);
        rc.x = rcGlisse.x + p.x - rcGlisse.px; rc.y = rcGlisse.y + p.y - rcGlisse.py;
        bornerRecadrage(); dessinerRecadrage();
      }
    });
    function lacher(ev) {
      rcDoigts.delete(ev.pointerId);
      if (rcDoigts.size < 2) rcPince = null;
      if (rcDoigts.size === 1) { var v = Array.from(rcDoigts.values())[0]; rcGlisse = { px: v.x, py: v.y, x: rc.x, y: rc.y }; }
      if (!rcDoigts.size) rcGlisse = null;
    }
    zone.addEventListener('pointerup', lacher);
    zone.addEventListener('pointercancel', lacher);
    zone.addEventListener('wheel', function (ev) {
      ev.preventDefault(); var p = local(ev); zoomRecadrage(Math.exp(-ev.deltaY * 0.0015), p.x, p.y);
    }, { passive: false });
    $('.aev__annuler').addEventListener('click', fermerRecadrage);
    $('.aev__utiliser').addEventListener('click', utiliserRecadrage);
  }
  window.addEventListener('resize', function () { if (rc && fenetre && !$('.aev__recadre').hidden) { mesurerRecadrage(false); dessinerRecadrage(); } });

  // ---------- ajustement à la main ----------
  function capturer(el, id) { try { el.setPointerCapture(id); } catch (e) { /* doigt déjà relâché */ } }
  function copie(pts) { return pts.map(function (p) { return { x: p.x, y: p.y }; }); }
  function position(i) { return LEVRES_EXT.indexOf(i) >= 0 ? LEVRES_EXT.indexOf(i) : NB_EXT + LEVRES_INT.indexOf(i); }
  function boite(pts) {
    var b = { x0: 1, y0: 1, x1: 0, y1: 0 };
    pts.slice(0, NB_EXT).forEach(function (p) { b.x0 = Math.min(b.x0, p.x); b.y0 = Math.min(b.y0, p.y); b.x1 = Math.max(b.x1, p.x); b.y1 = Math.max(b.y1, p.y); });
    return b;
  }
  function normaliser(pts, w, h) {
    var b = boite(pts), cx = (b.x0 + b.x1) / 2 * w, cy = (b.y0 + b.y1) / 2 * h, L = (b.x1 - b.x0) * w;
    return pts.map(function (p) { return [(p.x * w - cx) / L, (p.y * h - cy) / L]; });
  }
  function placerGabarit() {
    var w = toile.width, h = toile.height, L = w * 0.3, cx = w / 2, cy = h * 0.62;
    points = gabaritLevres.map(function (uv) { return { x: (cx + uv[0] * L) / w, y: (cy + uv[1] * L) / h }; });
  }
  function echelle() {
    var W = toile.offsetWidth, H = toile.offsetHeight, e = Math.min(W / toile.width, H / toile.height);
    return { W: W, H: H, e: e, ox: (W - toile.width * e) / 2, oy: (H - toile.height * e) / 2 };
  }
  function zoomer() {
    // la bouche au centre de l'écran, sur environ 70 % de sa largeur
    var s = echelle(), w = toile.width, h = toile.height, b = boite(points), scene = $('.aev__scene');
    var SW = scene.clientWidth, haut = $('.aev__barre').offsetHeight, SH = scene.clientHeight - haut;
    var cx = s.ox + (b.x0 + b.x1) / 2 * w * s.e, cy = s.oy + (b.y0 + b.y1) / 2 * h * s.e;
    var Z = Math.min(6, Math.min(SW * 0.7, SH * 1.2) / ((b.x1 - b.x0) * w * s.e));
    if (Z < 1.15) { vue = { Z: 1, tx: 0, ty: 0 }; toile.style.transform = ''; return; }
    vue = { Z: Z, tx: SW / 2 - toile.offsetLeft - Z * cx, ty: haut + SH / 2 - toile.offsetTop - Z * cy };
    toile.style.transformOrigin = '0 0';
    toile.style.transform = 'translate(' + vue.tx + 'px, ' + vue.ty + 'px) scale(' + Z + ')';
  }
  function versEcran(p) {
    var s = echelle();
    return { x: toile.offsetLeft + vue.tx + vue.Z * (s.ox + p.x * toile.width * s.e), y: toile.offsetTop + vue.ty + vue.Z * (s.oy + p.y * toile.height * s.e) };
  }
  function placerPoints() {
    if (!ajustement) return;
    $('.aev__calque').querySelectorAll('.aev__point').forEach(function (el) {
      var s = versEcran(points[Number(el.dataset.k)]);
      el.style.left = s.x + 'px'; el.style.top = s.y + 'px';
    });
  }
  // Chaque point se tire seul : aucun autre point de contrôle ne bouge. Les points du contour situés entre
  // deux points de contrôle suivent en proportion de leur distance à chacun, pour garder une courbe continue.
  // Contour intérieur : ses coins suivent les coins extérieurs (61 et 291), ses milieux sont 13 et 14.
  var ANCRES = null;
  function ancres() {
    if (ANCRES) return ANCRES;
    var ext = POIGNEES.filter(function (i) { return LEVRES_EXT.indexOf(i) >= 0; })
      .map(function (i) { return { pos: LEVRES_EXT.indexOf(i), maitre: LEVRES_EXT.indexOf(i) }; });
    var int = [
      { pos: LEVRES_INT.indexOf(78), maitre: LEVRES_EXT.indexOf(61) },
      { pos: LEVRES_INT.indexOf(308), maitre: LEVRES_EXT.indexOf(291) },
      { pos: LEVRES_INT.indexOf(14), maitre: NB_EXT + LEVRES_INT.indexOf(14) },
      { pos: LEVRES_INT.indexOf(13), maitre: NB_EXT + LEVRES_INT.indexOf(13) }
    ];
    function tri(a, b) { return a.pos - b.pos; }
    ANCRES = { ext: ext.sort(tri), int: int.sort(tri) };
    return ANCRES;
  }
  function poids(k, j) {
    var exterieur = j < NB_EXT, liste = exterieur ? ancres().ext : ancres().int;
    var n = exterieur ? NB_EXT : LEVRES_INT.length, i = exterieur ? j : j - NB_EXT;
    var avant = null, apres = null;
    for (var a = 0; a < liste.length; a++) {
      if (liste[a].pos === i) return liste[a].maitre === k ? 1 : 0;
      if (liste[a].pos < i) avant = liste[a];
      if (liste[a].pos > i && !apres) apres = liste[a];
    }
    if (!avant) avant = liste[liste.length - 1];   // le contour fait une boucle
    if (!apres) apres = liste[0];
    var dAvant = (i - avant.pos + n) % n, dApres = (apres.pos - i + n) % n, t = dAvant / (dAvant + dApres);
    return (avant.maitre === k ? 1 - t : 0) + (apres.maitre === k ? t : 0);
  }
  function deplacer(ev) {
    if (!glisse) return;
    var e = echelle().e;
    var dx = (ev.clientX - glisse.x) / (vue.Z * e * toile.width), dy = (ev.clientY - glisse.y) / (vue.Z * e * toile.height);
    points = glisse.depart.map(function (p, j) { var f = glisse.k === null ? 1 : poids(glisse.k, j); return { x: p.x + dx * f, y: p.y + dy * f }; });
    dessiner(); placerPoints();
  }
  function commencer(ev, k) {
    ev.stopPropagation(); ev.preventDefault();
    capturer(ev.currentTarget, ev.pointerId);
    glisse = { k: k, x: ev.clientX, y: ev.clientY, depart: copie(points), el: ev.currentTarget };
    if (k !== null) ev.currentTarget.classList.add('actif');
  }
  function finir() { if (glisse) { glisse.el.classList.remove('actif'); glisse = null; } }
  function centre(pts) { var b = boite(pts); return { x: (b.x0 + b.x1) / 2, y: (b.y0 + b.y1) / 2 }; }
  function etirer(depart, c, f, dx, dy) { return depart.map(function (p) { return { x: c.x + (p.x - c.x) * f + dx, y: c.y + (p.y - c.y) * f + dy }; }); }
  function brancherCalque() {
    var calque = $('.aev__calque');
    calque.addEventListener('pointerdown', function (ev) {
      if (ev.target !== calque) return;
      capturer(calque, ev.pointerId);
      doigts.set(ev.pointerId, { x: ev.clientX, y: ev.clientY });
      if (doigts.size === 2) {
        glisse = null;
        var v = Array.from(doigts.values());
        pince = { d: Math.hypot(v[0].x - v[1].x, v[0].y - v[1].y), mx: (v[0].x + v[1].x) / 2, my: (v[0].y + v[1].y) / 2, depart: copie(points), c: centre(points) };
      } else if (doigts.size === 1) commencer(ev, null);
    });
    calque.addEventListener('pointermove', function (ev) {
      if (!doigts.has(ev.pointerId)) return;
      doigts.set(ev.pointerId, { x: ev.clientX, y: ev.clientY });
      if (pince && doigts.size >= 2) {
        var v = Array.from(doigts.values()), e = echelle().e;
        var f = Math.hypot(v[0].x - v[1].x, v[0].y - v[1].y) / pince.d;
        var dx = ((v[0].x + v[1].x) / 2 - pince.mx) / (vue.Z * e * toile.width), dy = ((v[0].y + v[1].y) / 2 - pince.my) / (vue.Z * e * toile.height);
        points = etirer(pince.depart, pince.c, f, dx, dy);
        dessiner(); placerPoints();
      } else deplacer(ev);
    });
    function lacher(ev) { doigts.delete(ev.pointerId); if (doigts.size < 2) pince = null; if (!doigts.size) finir(); }
    calque.addEventListener('pointerup', lacher);
    calque.addEventListener('pointercancel', lacher);
    calque.addEventListener('wheel', function (ev) {
      ev.preventDefault();
      points = etirer(points, centre(points), Math.exp(-ev.deltaY * 0.0015), 0, 0);
      dessiner(); placerPoints();
    }, { passive: false });
  }
  function construirePoints() {
    var calque = $('.aev__calque');
    calque.querySelectorAll('.aev__point').forEach(function (el) { el.remove(); });
    POIGNEES.forEach(function (i) {
      var el = document.createElement('div');
      el.className = 'aev__point'; el.dataset.k = position(i);
      el.addEventListener('pointerdown', function (ev) { commencer(ev, Number(el.dataset.k)); });
      el.addEventListener('pointermove', deplacer);
      el.addEventListener('pointerup', finir); el.addEventListener('pointercancel', finir);
      calque.appendChild(el);
    });
    placerPoints();
  }
  function loger() {
    // la photo logée à ses proportions dans la zone (Safari étire un canvas au lieu d'appliquer object-fit)
    if (!fenetre || !fenetre.parentNode) return;
    var scene = $('.aev__scene'), cs = getComputedStyle(scene);
    var SW = scene.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    var SH = scene.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
    if (SW <= 0 || SH <= 0) return;
    var e = Math.min(SW / toile.width, SH / toile.height);
    toile.style.width = Math.round(toile.width * e) + 'px';
    toile.style.height = Math.round(toile.height * e) + 'px';
    // « Ajuster les lèvres » dans le coin de la photo, pas dans la marge blanche autour
    var aj = $('.aev__ajuster');
    aj.style.left = (toile.offsetLeft + 10) + 'px'; aj.style.top = (toile.offsetTop + 10) + 'px';
    var ag = $('.aev__agrandir');
    ag.style.left = (toile.offsetLeft + toile.offsetWidth - 46) + 'px'; ag.style.top = (toile.offsetTop + toile.offsetHeight - 46) + 'px';
  }
  function entrerAjustement() {
    if (!source) return;
    if (comparer) $('.aev__comparer').click();
    var auJuge = !pointsDetectes;
    if (!points) { if (!gabaritLevres) return; placerGabarit(); }
    ajustement = true;
    fenetre.classList.add('aev--ajuste');
    $('.aev__calque').hidden = false; $('.aev__barre').hidden = false; etat('');
    toile.style.transition = 'none';
    loger();
    if (!auJuge) zoomer();
    dessiner(); construirePoints();
    requestAnimationFrame(function () { toile.style.transition = ''; placerPoints(); });
  }
  function quitterAjustement() {
    ajustement = false; glisse = null; pince = null; doigts.clear();
    fenetre.classList.remove('aev--ajuste');
    $('.aev__calque').hidden = true; $('.aev__barre').hidden = true;
    vue = { Z: 1, tx: 0, ty: 0 };
    toile.style.transform = ''; toile.style.transformOrigin = '';
    loger();
    dessiner();
  }
  window.addEventListener('resize', function () {
    if (!source) return;
    loger();
    if (ajustement) { zoomer(); placerPoints(); dessiner(); }
  });

  racine.querySelector('[data-essai-ouvrir]').addEventListener('click', ouvrir);
})();
